import React, { useEffect, useState, useMemo, useRef } from "react";
import { flushSync } from "react-dom";
import eligibilityCheckServices from "../../services/api/service/eligibilityCheckService";
import dropdownService from "../../services/api/service/dropdownService";
import {
  Box,
  Grid,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
  Typography,
  Button,
  Card,
  CardContent,
  Skeleton,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import { DescriptionOutlined as DocumentIcon } from "@mui/icons-material";
import CollapsibleSection from "../common-features/CollapsibleSection";
import { useApplicantMasterData } from "../../hooks/useApplicantMasterData";
import FormEdit from "../../components/ui/StepperDyanmicForm/FormEdit";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
// Lightweight ErrorBoundary to catch runtime errors inside inline editors
class InlineErrorBoundary extends React.Component<{
  children: React.ReactNode;
  onReset?: () => void;
}, { hasError: boolean; error?: Error | null }> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Inline editor error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 2 }}>
          <Typography color="error" sx={{ mb: 1 }}>
            Unable to load editor.
          </Typography>
          <Button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              this.props.onReset?.();
            }}
          >
            Close
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
import { useDispatch, useSelector } from "react-redux";
import { fetchUserApplicationsFormData } from "../../services/api/service/userApplicationService";
import applicationDetailsServices from "../../services/api/service/applicationDetails";
import { AppDispatch, RootState,store } from "../../services/redux/store";
import DetailRow from "../common-features/DetailRow";
import ModalPopup from "../../components/ui/ModalPopup";
import { authSelector } from "../../services/redux/slices/authSlice";
// import successProvisionalOffer from "./../../assets/images/success_provisional_offer.png";
import successProvisionalOffer from "./../../assets/svgIcons/provision-sucess.svg";
import failedProvisionalOffer from "./../../assets/images/failed_provisional_offer.png";
import pendingProvisionalOffer from "./../../assets/svgIcons/pending_provisional_offer.svg";
import eligibilityCheckIcon from "./../../assets/svgIcons/clipboardCheckAppDetails.svg";
import applicantAndLoanDetailsIcon from "./../../assets/svgIcons/list-detailsAppDetails.svg";
import provisionalOfferLetterIcon from "./../../assets/svgIcons/mailOpenedAppDetails.svg";
import addtionalDetailsAndDocumentsIcon from "./../../assets/svgIcons/idAppDetails.svg";
import finalVerificationAndSanctionIcon from "./../../assets/svgIcons/file-textAppDetails.svg";
import coApplicantIcon from "./../../assets/svgIcons/users.svg";
import DisbursementOfFundsIcon from "./../../assets/icons/file-check.png";
import leftConfetti from "./../../assets/svgIcons/left-confetti.svg";
import rightConfetti from "./../../assets/svgIcons/right-confetti.svg";
import {
  setApplicantLoanDetails,
  setAcademicDetails,
  setEntranceDetails,
  setLoanDetails,
  setEmploymentDetails,
  setExpenseDetails,
  setAppLoanDetails,
  setReferenceDetails,
  setCoApplicantDetails,
  setCoApplicantCompletionRate,
  setCollateralDetails,
  setEducationGap,
} from "../../services/redux/slices/applicationLoanDetailsSlice";

import postsServices from "../../services/api/service/postsService";
import losServices from "../../services/api/service/losService";
import EntranceExamDetailsTab from "../../components/applicantDetailsTabs/EntranceExamDetailsTab";
import LoanDetailsTab from "../../components/applicantDetailsTabs/LoanDetailsTab";
import StudentDetailsTab from "../../components/applicantDetailsTabs/StudentDetailsTab";
import AddressDetailsTab from "../../components/applicantDetailsTabs/AddressDetailsTab";
import EmploymentDetailsTab from "../../components/applicantDetailsTabs/EmploymentDetailsTab";
import AcademicDetailsTab from "../../components/applicantDetailsTabs/AcademicDetailsTab";
import ExpenseDetailsTab from "../../components/applicantDetailsTabs/ExpenseDetailsTab";
import ApplicantAdditionalTab from "../../components/applicantDetailsTabs/ApplicantAdditionalTab";
import ReferenceDetailsTab, {
  referenceDetailsSkeleton,
} from "../../components/applicantDetailsTabs/ReferenceDetailsTab";
import CoApplicantTabs from "../../components/applicantDetailsTabs/CoApplicantTabs";
import BottomSheet from "../../components/ui/BottomSheet";
import CollateralDetailsTab from "../../components/applicantDetailsTabs/CollateralDetailsTab";
import ProvideConsentDetailsTab from "../../components/applicantDetailsTabs/ProvideConsentDetailsTab";
import ProvideCourseDetailsTab from "../../components/applicantDetailsTabs/ProvideCourseDetailsTab";
import ProvideLoanDetailsTab from "../../components/applicantDetailsTabs/ProvideLoanDetailsTab";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {getCoApplicantList,mergeAndCalculateCompletion,getCoApplicantAverageProgress,getVerticalStepLabel,resolveReduxVerticalIndex,mergeMissingCoApplicants,syncResponse1ToResponse2,getCoApplicantFieldIds, mapGender,getCoAppPercentageByIndices,isReferenceCollateralVerticalStepLabel } from "../../utils/helpers";
import { ROUTES } from "../../routes/routerConfig";
import { setActiveHorizontalIndex, setActiveVerticalIndex,
   setPartnerStartedJourney,
   requestSummaryFormSave,
  setSummaryApplicationEditActive,
  setSkipNextSummaryRefetch,
  setLoanDetailCoApplicantCollapseValue,setHorizontalSteps, setFetchUserApplicationData, clearFormData, updateFormData, setIsDocumentVerified } from "../../services/redux/slices/stepperDynamicFormSlice";
import { getFormJson } from "../../services/redux/thunks/stepperDynamicFormThunks";

import { setStatusPopup } from "../../services/redux/slices/statusPopupSlice";
import { useNavigate } from "react-router-dom";
import { getOrderedData } from "./helper";
import { trackCustomerJourneyEvent } from "../../utils/ga";
import { decrypt } from "../../utils/crypto";
// --- Helper Functions and Interfaces ---
function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const toTitleLabel = (key: string): string => {
  return key
    .replace(/[_-]+/g, " ")
    .replace(/([A-Z])/g, " $1")
    .replace(/\s+/g, " ")
    .replace(/^./, (str) => str.toUpperCase())
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
    .trim();
};

const normalizeKey = (value: string): string =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

const isCombinedReferenceCollateralStep = (stepName: string): boolean => {
  const normalized = normalizeKey(stepName);
  if (!normalized) return false;

  // Already split on the frontend — do not split again.
  if (
    normalized === normalizeKey("Reference Details") 
    ||
     normalized === normalizeKey("Collateral Details")
  ) {
    return false;
  }

  // Backend may send slightly different labels for the combined step.
  return normalized.includes("reference") && normalized.includes("collateral");
};

const splitReferenceCollateralVerticalSteps = (
  steps: VerticalStep[] = [],
): VerticalStep[] => {
  const splitSteps: VerticalStep[] = [];

  steps.forEach((step) => {
    const stepName = step?.verticalStepName || (step as any)?.stepLabel || "";
    if (isCombinedReferenceCollateralStep(stepName)) {
      splitSteps.push({
        ...step,
        verticalStepName: "Reference Details",
      });
      splitSteps.push({
        ...step,
        verticalStepName: "Collateral Details",
      });
      return;
    }

    splitSteps.push(step);
  });

  return splitSteps;
};

const resolveEditorVerticalStepLabel = (
  applicationLabel: string,
  verticalStepName: string,
  uiVerticalIndex: number,
  reduxHorizontalSteps: any[],
): string => {
  const normalizedStepName = normalizeKey(verticalStepName);
  if (
    normalizedStepName === normalizeKey("Reference Details") 
    ||
    normalizedStepName === normalizeKey("Collateral Details")
  ) {
    const horizontalStep = reduxHorizontalSteps?.find(
      (step: any) => step?.stepLabel === applicationLabel,
    );
    const combinedStep = horizontalStep?.verticalSteps?.find((step: any) =>
      isCombinedReferenceCollateralStep(
        step?.stepLabel || step?.verticalStepName || "",
      ),
    );
    return combinedStep?.stepLabel || "Reference & Collateral Details";
  }

  return getVerticalStepLabel(
    applicationLabel,
    uiVerticalIndex,
    reduxHorizontalSteps,
  );
};
// Type for co-applicant field value
type CoApplicantFieldValue = string | number | boolean | null | undefined;

const CO_APPLICANT_SOURCE_STEPS = [
  { horizontalIndex: 1, verticalIndex: 5 },
  { horizontalIndex: 3, verticalIndex: 1 },
  { horizontalIndex: 4, verticalIndex: 1 },
];

// Same required-field set as the "Basic Details" section of the apiFields
// template in addCoApplicantFields below (name suffixes only).
const REQUIRED_BASIC_COAPPLICANT_SUFFIXES = [
  "RelationWithStudent",
  "salutation",
  "FirstName",
  "LastName",
];

// "Add More" should only enable once the most recently added co-applicant's
// own Basic Details are filled in — mirroring CoApplicantDetailsSection.tsx's
// hasRemainingUnsavedBlankCoApplicant, which gates the stepper's own Add
// More the same way, just checking required basicCoApplicant{N} fields.
//
// `coApplicantCountFromApi` (from the same api/v1/applicant/get-coapplicant-count
// call addCoApplicantFields already makes) is the authoritative source of how
// many co-applicants actually exist server-side. In-session, a newly added but
// still-blank co-applicant is backfilled into `coApplicantToShow` via
// mergeMissingCoApplicants using state.stepper.horizontalSteps as a safety
// net — but that redux slice isn't persisted, so right after a page refresh
// it's empty and that backfill doesn't happen. Without the count check below,
// a co-applicant the backend already knows about but that hasn't shown up in
// this fetch yet would be invisible to this function, silently falling back
// to evaluating the previous (already complete) co-applicant and wrongly
// re-enabling the button.
const shouldDisableAddMoreCoApplicant = (
  coApplicantToShow: any,
  coApplicantCountFromApi: number | null,
): boolean => {
  const groups: Array<{ num: number; fields: any[] }> = [];
  if (Array.isArray(coApplicantToShow)) {
    coApplicantToShow.forEach((coAppObj: any) => {
      const coAppKey = Object.keys(coAppObj || {}).find((k) =>
        k.startsWith("coapplicant"),
      );
      if (!coAppKey) return;
      const num = Number(coAppKey.replace(/[^\d]/g, "")) || 0;
      if (num > 0 && Array.isArray(coAppObj[coAppKey])) {
        groups.push({ num, fields: coAppObj[coAppKey] });
      }
    });
  }

  if (
    coApplicantCountFromApi != null &&
    coApplicantCountFromApi > groups.length
  ) {
    return true;
  }

  if (groups.length === 0) return false;

  const last = groups.reduce((a, b) => (b.num > a.num ? b : a));

  return REQUIRED_BASIC_COAPPLICANT_SUFFIXES.some((suffix) => {
    const fieldName = `basicCoApplicant${last.num}${suffix}`;
    const field = last.fields.find((f: any) => f?.key === fieldName);
    const value = field?.value;
    return value === undefined || value === null || value === "";
  });
};

const buildMergedCoApplicantDetails = (horizontalSteps: any[] = []) => {
  const mergedFields = getCoApplicantList({ horizontalSteps });
  const grouped: Record<string, any> = {};

  mergedFields.forEach((item: any) => {
    const [key, value] = Object.entries(item || {})[0] || [];
    const match = String(key || "").match(/^basicCoApplicant(\d+)(.+)/);

    if (!match) {
      return;
    }

    const [, groupNumber, field] = match;
    const coApplicantKey = `coapplicant${groupNumber}`;
    if (!grouped[coApplicantKey]) {
      grouped[coApplicantKey] = {};
    }
    grouped[coApplicantKey][field] = value;
  });

  return Object.keys(grouped).length > 0 ? grouped : null;
};

interface Field {
  [key: string]: any;
}
interface VerticalStep {
  verticalStepName: string;
  fields: Field[];
}
interface HorizontalStep {
  horizontalStepName: string;
  verticalSteps: VerticalStep[];
  completionRate?: number;
}
interface Application {
  horizontalSteps: HorizontalStep[];
  submissionId: string;
  isProvisionalGenerated?: boolean;
  isQualified?: boolean;
  isEligibilityChecked?: boolean | null;
}
interface CombinedStep {
  label: string;
  completionRate: string;
  status: "pending" | "completed";
  innerData: VerticalStep[];
  isEligible?: boolean | null;
}
type RawDataItem = {
  [key: string]: string | number | boolean | undefined;
};
type FormattedItem = {
  label: string;
  value: string | number | boolean | undefined;
  isVerified: boolean;
};
interface DetailRowComponentProps {
  item: FormattedItem;
}
type DetailRowType = React.FC<DetailRowComponentProps>;
interface InnerDetailsTabsProps {
  innerData: VerticalStep[];
  activeTabIndex: number;
  activeHandleChange: (event: React.SyntheticEvent, newValue: number) => void;
  isXsOrSm: boolean;
}
interface ApplicationDetailsTabsProps {
  application: CombinedStep;
  tabIndex: number;
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
  title: string;
  completionRate: string;
  onClose: () => void;
  isLoanDetailsLoading: boolean;
  isXsOrSm: boolean;
  coApplicantDetails: any;
  coApplicantCompletionRate: any;
  designationsVal:any;
  maritalStatusMap?: Record<string, string>;
  pageTypeSummary?:any;
  onRemoveCoApplicant?: (coApplicantNumber: number) => Promise<void> | void;
}
interface ApplicationDetailsProps {
  pageTypeSummary?: string;
}
const eligibilitySectionActionMap: Record<
  string,
  { label: string; clickable: boolean }
> = {
  "Verify Yourself and Provide Consent": {
    label: "Edit",
    clickable: true,
  },
  "Provide Course Details": {
    label: "Edit",
    clickable: true,
  },
  "Provide Loan Details": {
    label: "Edit",
    clickable: true,
  },
  Eligibility: {
    label: "View",
    clickable: true,
  },
  "Student Details": {
    label: "Edit",
    clickable: true,
  },
  "Address Details": {
    label: "Edit",
    clickable: true,
  },
  "Employment Details": {
    label: "Edit",
    clickable: true,
  },
  "Academic Details": {
    label: "Edit",
    clickable: true,
  },
  "Entrance Exam Details": {
    label: "Edit",
    clickable: true,
  },
  // "Loan Details": {
  //   label: "Edit",
  //   clickable: true,
  // },
  "Applicant Additional Details": {
    label: "Edit",
    clickable: true,
  },
  "Funds & Expenses": {
    label: "Edit",
    clickable: true,
  },
  "Funds and Expenses": {
    label: "Edit",
    clickable: true,
  },
  "Reference & Collateral Details": {
    label: "Edit",
    clickable: true,
  },
  "Reference Details": {
    label: "Edit",
    clickable: true,
  },
  "Collateral Details": {
    label: "Edit",
    clickable: true,
  },
};

const defaultApplicantLoanDetailsTabs: VerticalStep[] = [
  { verticalStepName: "Student Details", fields: [] },
  { verticalStepName: "Address Details", fields: [] },
  { verticalStepName: "Employment Details", fields: [] },
  { verticalStepName: "Academic Details", fields: [] },
  { verticalStepName: "Entrance Exam Details", fields: [] },
  // { verticalStepName: "Loan Details", fields: [] },
];

const defaultEligibilityCheckTabs: VerticalStep[] = [
  { verticalStepName: "Verify Yourself and Provide Consent", fields: [] },
  { verticalStepName: "Provide Course Details", fields: [] },
  { verticalStepName: "Provide Loan Details", fields: [] },
];

const defaultAdditionalDetailsTabs: VerticalStep[] = [
  { verticalStepName: "Applicant Additional Details", fields: [] },
  { verticalStepName: "Funds & Expenses", fields: [] },
  { verticalStepName: "Reference Details", fields: [] },
  { verticalStepName: "Collateral Details", fields: [] },
];

const normalizeVerticalStepName = (name: string): string =>
  String(name || "")
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]/g, "");

/**
 * Always keep full default section cards. Overlay backend stage data when present
 * so a partially completed journey still shows all stages (not only filled ones).
 */
const mergeVerticalStepsWithDefaults = (
  apiSteps: VerticalStep[] = [],
  defaultSteps: VerticalStep[] = [],
): VerticalStep[] => {
  if (!defaultSteps.length) {
    return Array.isArray(apiSteps) ? apiSteps : [];
  }

  const apiByName = new Map<string, VerticalStep>();
  (apiSteps || []).forEach((step) => {
    const key = normalizeVerticalStepName(step?.verticalStepName || "");
    if (key) apiByName.set(key, step);
  });

  const merged = defaultSteps.map((defaultStep:any) => {
    const key = normalizeVerticalStepName(defaultStep.verticalStepName || "");
    const apiStep:any = apiByName.get(key);
    if (!apiStep) {
      return {
        ...defaultStep,
        completionRate: defaultStep?.completionRate ?? "0%",
        fields: defaultStep.fields || [],
      };
    }

    return {
      ...defaultStep,
      ...apiStep,
      verticalStepName: defaultStep.verticalStepName,
      fields:
        Array.isArray(apiStep.fields) && apiStep.fields.length > 0
          ? apiStep.fields
          : defaultStep.fields || [],
      completionRate: apiStep?.completionRate ?? "0%",
    };
  });

  // Preserve unexpected backend-only stages (except known exclusions).
  (apiSteps || []).forEach((apiStep) => {
    const key = normalizeVerticalStepName(apiStep?.verticalStepName || "");
    if (!key) return;
    if (key === normalizeVerticalStepName("Co-Applicant Aditional Details")) return;
    if (key === normalizeVerticalStepName("Co-Applicant Details")) return;
    const alreadyIncluded = defaultSteps.some(
      (d) => normalizeVerticalStepName(d.verticalStepName || "") === key,
    );
    if (!alreadyIncluded) {
      merged.push(apiStep);
    }
  });

  return merged;
};

const getDefaultVerticalStepsForSection = (
  sectionLabel: string,
): VerticalStep[] => {
  const normalized = normalizeVerticalStepName(sectionLabel);
  if (normalized === normalizeVerticalStepName("Eligibility Check")) {
    return defaultEligibilityCheckTabs;
  }
  if (normalized === normalizeVerticalStepName("Applicant & Loan Details")) {
    return defaultApplicantLoanDetailsTabs;
  }
  if (
    normalized === normalizeVerticalStepName("Additional Details & Documents")
  ) {
    return defaultAdditionalDetailsTabs;
  }
  return [];
};

const TabPanel: React.FC<{
  children?: React.ReactNode;
  index: number;
  value: number;
  isMobile?: boolean
}> = ({ children, value, index, isMobile, ...other }) => {
  const isReferenceDetails = React.isValidElement(children) && children.props?.verticalStep?.verticalStepName === "Reference Details";

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: isMobile ? 0 : isReferenceDetails ? 0 : 2, pt: 0 }}>{children}</Box>}
    </div>
  );
};

export const tabContentSkeleton = () =>
  Array.from({ length: 8 })?.map((_, idx) => (
    <Grid
      item
      xs={12}
      sm={6}
      md={3}
      sx={{ mb: 2 }}
      key={`student-skeleton-${idx}`}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height={15}
        sx={{ borderRadius: "4px", mb: 1 }}
      />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={15}
        sx={{ borderRadius: "8px" }}
      />
    </Grid>
  ));

const formatDataHelper = (
  data: RawDataItem[],
  partnerStartedJourney: boolean,
  maritalStatusMap?: Record<string, string>,
  resolveCityOfBirth?: (rawValue: any, merged: RawDataItem) => any
): FormattedItem[] => {
  const merged: RawDataItem = {};
  const tempLabels: { [key: string]: string } = {};

  !partnerStartedJourney &&
    data?.forEach((item) => {
      Object.entries(item).forEach(([key, value]) => {
        tempLabels[key.toLowerCase()] = toTitleLabel(key);
        merged[key.toLowerCase()] = value;
      });
    });

  const formattedItems: FormattedItem[] = [];

  Object.entries(merged).forEach(([key, value]) => {
    if (key.includes("verified")) return;

    // Resolve short codes to their full display names — marital status codes
    // (e.g. "M") and city-of-birth codes both come back from the backend as
    // codes rather than human-readable text.
    let resolvedValue = value;
    if (key.includes("maritalstatus") && value != null && value !== "") {
      resolvedValue =
        maritalStatusMap?.[String(value).trim().toUpperCase()] ?? value;
    } else if (key.includes("cityofbirth") && value != null && value !== "") {
      resolvedValue = resolveCityOfBirth?.(value, merged) ?? value;
    }

    let isVerified = false;
    if (
      key === "phone_number" &&
      (merged?.["ismobileverified"] === true ||
        merged?.["ismobileverified"] === "true")
    ) {
      isVerified = true;
    } else if (
      key === "email" &&
      (merged?.["isemailverified"] === true ||
        merged?.["isemailverified"] === "true")
    ) {
      isVerified = true;
    } else {
      const verifyKeyVariants: string[] = [
        `is${key}verified`,
        `${key}verified`,
        `${key}_verified`,
        `${key}verified`,
      ];
      for (const vKey of verifyKeyVariants) {
        if (vKey in merged) {
          const v = merged[vKey];
          isVerified = typeof v === "boolean" ? v : v === "true";
          break;
        }
      }
    }

    const label = tempLabels[key];
    if (
      label &&
      !label.toLowerCase().includes("terms conditions") &&
      !label.toLowerCase().includes("privacy policy")
    ) {
      formattedItems.push({
        label,
        value: resolvedValue,
        isVerified,
      });
    }
  });

  return formattedItems;
};
const InnerDetailsTabs: React.FC<InnerDetailsTabsProps> = React.memo(
  ({ innerData, activeTabIndex, activeHandleChange, isXsOrSm }) => (
    <Tabs
      value={activeTabIndex}
      onChange={activeHandleChange}
      variant={isXsOrSm ? "scrollable" : "standard"}
      {...(isXsOrSm && {
        scrollButtons: "auto",
        allowScrollButtonsMobile: false,
      })}
      sx={{
        flexGrow: 1,
        ...(isXsOrSm
          ? {
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTabs-flexContainer": { gap: "8px", flexWrap: "nowrap" },
              "& .MuiTabs-scroller": { paddingBottom: "1px" },
              mb: 3,
            }
          : {
              mb: 2,
              borderBottom: 1,
              borderColor: "divider",
              "& .MuiTabs-indicator": { backgroundColor: "#00b3b5" },
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                color: "#616161",
                "&.Mui-selected": { color: "#00b3b5" },
              },
            }),
      }}
    >
      {innerData?.map((item: any, i: any) => (
        <Tab
          key={item?.verticalStepName}
          label={
            isXsOrSm ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {item?.verticalStepName}
              </Box>
            ) : (
              item?.verticalStepName
            )
          }
          {...a11yProps(i)}
          sx={
            isXsOrSm
              ? {
                  textTransform: "none",
                  fontWeight: 600,
                  color: "#616161",
                  padding: "10px 18px",
                  // borderRadius: "24px",
                  fontSize: "13px",
                  // border: "1px solid #E0E0E0",
                  backgroundColor: "#FFFFFF",
                  transition: "all 0.3s ease",
                  minHeight: { xs: "38px !important", sm: "auto" },
                  "&.Mui-selected": {
                    color: "#00b3b5",
                    // backgroundColor: "rgb(0 179 181 / 10%)",
                    borderColor: "#00b3b5",
                    borderBottom: "1px solid"
                  },
                  "&.MuiTab-root": { margin: 0, padding: "10px 18px" },
                }
              : {}
          }
        />
      ))}
    </Tabs>
  )
);

// it will render the content for a specific vertical step tab
const RenderTabContent: React.FC<{
  applicationLabel: string;
  verticalStep: VerticalStep;
  isMobile?: boolean;
  isLoanDetailsLoading: boolean;
  designationsVal?:any;
  maritalStatusMap?: Record<string, string>;
  pageTypeSummary?:string;
}> = ({ applicationLabel, verticalStep, isMobile = false, isLoanDetailsLoading, designationsVal, maritalStatusMap,
  pageTypeSummary
}) => {
  const {
    studentDetails,
    addressDetails,
    employmentDetails,
    companyAddressDetails,
    academicDetails,
    entranceDetails,
    loanDetails,
    expenseDetails,
    referenceDetails,
    collateralDetails,
    partnerDetails,
    educationGap,
    appLoanDetails,
  } = useSelector((state: RootState) => state?.applicationLoanDetailsData);
  
  const { fetchUserApplicationData } = useSelector(
    (state: RootState) => state?.stepper
  );
  const TypedDetailRow = DetailRow as DetailRowType;

  const { fetchCitiesByCountryState, getCityOptionsForCountry, countryOptions } =
    useApplicantMasterData();

  // Country of Birth is saved as a country code (see the CoApplicant save
  // flow's birthCountryId), but the cities-by-country API is keyed by the
  // full country name — resolve internally only for that lookup. This does
  // NOT change how the Country of Birth row itself is displayed.
  const resolveBirthCountryName = (rawCountryValue: any): string => {
    const raw = String(rawCountryValue ?? "");
    if (!raw) return raw;
    const match = countryOptions.find(
      (opt) =>
        String((opt as any)?.countryId ?? "").toLowerCase() === raw.toLowerCase() ||
        String(opt.value).toLowerCase() === raw.toLowerCase() ||
        String(opt.label).toLowerCase() === raw.toLowerCase()
    );
    return match?.label ?? raw;
  };

  // City-of-birth values come back from the backend as short city codes.
  // Resolving a code to its full city name requires the city master list for
  // whichever country that field belongs to, so prefetch every distinct
  // birth country referenced by this step's raw fields (there can be more
  // than one — each co-applicant may have a different birth country).
  useEffect(() => {
    if (!Array.isArray(verticalStep?.fields)) return;
    if (countryOptions.length === 0) return;

    const birthCountries = new Set<string>();
    verticalStep.fields.forEach((item: any) => {
      Object.keys(item || {}).forEach((key) => {
        if (String(key).toLowerCase().includes("cityofbirth")) {
          const countryKey = key.replace(/cityofbirth/i, "CountryOfBirth");
          const countryEntry = verticalStep.fields.find(
            (f: any) => countryKey in (f || {})
          );
          const countryValue = countryEntry?.[countryKey];
          if (countryValue) {
            birthCountries.add(resolveBirthCountryName(countryValue));
          }
        }
      });
    });

    birthCountries.forEach((countryLabel) => {
      if (getCityOptionsForCountry(countryLabel).length === 0) {
        fetchCitiesByCountryState(countryLabel);
      }
    });
  }, [verticalStep?.fields, fetchCitiesByCountryState, getCityOptionsForCountry, countryOptions]);

  const resolveCityOfBirth = (rawValue: any, merged: RawDataItem) => {
    // Find the sibling "...CountryOfBirth" key for whichever "...CityOfBirth"
    // key produced this value, so the lookup uses the right country's cities.
    const cityKey = Object.keys(merged).find(
      (k) => merged[k] === rawValue && k.includes("cityofbirth")
    );
    if (!cityKey) return rawValue;
    const countryKey = cityKey.replace("cityofbirth", "countryofbirth");
    const rawCountryValue = merged[countryKey];
    if (!rawCountryValue) return rawValue;
    const countryLabel = resolveBirthCountryName(rawCountryValue);

    const cityOptions = getCityOptionsForCountry(String(countryLabel));
    const match = cityOptions.find(
      (opt) =>
        String(opt.value).toLowerCase() === String(rawValue).toLowerCase() ||
        String(opt.label).toLowerCase() === String(rawValue).toLowerCase()
    );
    return match?.label ?? rawValue;
  };

  const normalizedApplicationLabel = normalizeKey(applicationLabel);
  const normalizedVerticalStepName = normalizeKey(verticalStep?.verticalStepName || "");

  const isEligibilityDetails = normalizedApplicationLabel === normalizeKey("Eligibility Check");
  const isApplicantLoanDetails = normalizedApplicationLabel === normalizeKey("Applicant & Loan Details");
  const isAdditionalDetails =
    normalizedApplicationLabel.includes("additionaldetails") &&
    normalizedApplicationLabel.includes("document");

  const consentDetailsTabs: Record<string, string> = {
    [normalizeKey("Verify Yourself and Provide Consent")]: "isProvideConsentDetailsTab",
    [normalizeKey("Provide Course Details")]: "isProvideCourseDetailsTab",
    [normalizeKey("Provide Loan Details")]: "isProvideLoanDetailsTab",
  };

  const detailsTabs: Record<string, string> = {
    [normalizeKey("Student Details")]: "isStudentDetailsTab",
    [normalizeKey("Address Details")]: "isAddressDetailsTab",
    [normalizeKey("Employment Details")]: "isEmploymentDetailsTab",
    [normalizeKey("Academic Details")]: "isAcademicDetailsTab",
    [normalizeKey("Entrance Exam Details")]: "isEntranceExamDetailsTab",
    // [normalizeKey("Loan Details")]: "isLoanDetailsTab",
  };

  const additionalDetailsTabs: Record<string, string> = {
    [normalizeKey("Applicant Additional Details")]:"isApplicantAdditionalDetailsTab",
    [normalizeKey("Funds & Expenses")]: "isExpenseDetailsTab",
    [normalizeKey("Funds and Expenses")]: "isExpenseDetailsTab",
    [normalizeKey("Reference & Collateral Details")]: "isReferenceDetailsTab",
    [normalizeKey("Reference Details")]: "isReferenceDetailsTab",
    [normalizeKey("Collateral Details")]: "isCollateralDetailsTab",
  };

  let activeTab: string | undefined;
  if (isEligibilityDetails) {
    activeTab = consentDetailsTabs[normalizedVerticalStepName];
  } else if (isApplicantLoanDetails) {
   
    activeTab = detailsTabs[normalizedVerticalStepName];
  } else if (isAdditionalDetails) {
    activeTab = additionalDetailsTabs[normalizedVerticalStepName];
   
    if (!activeTab) {
      if (normalizedVerticalStepName.includes("funds")) {
        activeTab = "isExpenseDetailsTab";
      } else if (normalizedVerticalStepName.includes("reference")) {
        activeTab = "isReferenceDetailsTab";
      } else if (normalizedVerticalStepName.includes("collateral")) {
        activeTab = "isCollateralDetailsTab";
      }
    }
  }

  const isProvideConsentDetailsTab = activeTab === "isProvideConsentDetailsTab";
  const isProvideCourseDetailsTab = activeTab === "isProvideCourseDetailsTab";
  const isProvideLoanDetailsTab = activeTab === "isProvideLoanDetailsTab";
  const isStudentDetailsTab = activeTab === "isStudentDetailsTab";
  const isAddressDetailsTab = activeTab === "isAddressDetailsTab";
  const isEmploymentDetailsTab = activeTab === "isEmploymentDetailsTab";
  const isAcademicDetailsTab = activeTab === "isAcademicDetailsTab";
  const isEntranceExamDetailsTab = activeTab === "isEntranceExamDetailsTab";
  const isLoanDetailsTab = activeTab === "isLoanDetailsTab";
  const isExpenseDetailsTab = activeTab === "isExpenseDetailsTab";
  const isApplicantAdditionalDetailsTab = activeTab === "isApplicantAdditionalDetailsTab";
  const isReferenceDetailsTab = activeTab === "isReferenceDetailsTab";
  const isCollateralDetailsTab = activeTab === "isCollateralDetailsTab";
  const isCustomTab =
    isProvideConsentDetailsTab ||
    isProvideCourseDetailsTab ||
    isProvideLoanDetailsTab ||
    isStudentDetailsTab ||
    isAddressDetailsTab ||
    isEmploymentDetailsTab ||
    isAcademicDetailsTab ||
    isEntranceExamDetailsTab ||
    isLoanDetailsTab ||
    isExpenseDetailsTab ||
    isApplicantAdditionalDetailsTab|| 
    isReferenceDetailsTab ||
    isCollateralDetailsTab;


    const buildReferenceSectionsFromRawFields = (rawFields: any[]): any[] => {
    if (!Array.isArray(rawFields) || rawFields.length === 0) return [];

    const grouped = new Map<number, any[]>();

    const getReferenceIndex = (name: string, label: string, fallback: number) => {
      const source = `${name} ${label}`.toLowerCase();
      const specificMatch = source.match(
        /(?:basic|address)reference\s*(\d+)|(?:basic|address)reference(\d+)/i,
      );
      if (specificMatch?.[1] || specificMatch?.[2]) {
        return Number(specificMatch[1] || specificMatch[2]);
      }

      const genericMatch = source.match(/reference\s*(\d+)|reference(\d+)/i);
      return Number(genericMatch?.[1] || genericMatch?.[2]) || fallback;
    };

    rawFields.forEach((field: any, index: number) => {
      if (!field || typeof field !== "object") return;

      let name = "";
      let label = "";
      let value: any = "";

      if (
        Object.prototype.hasOwnProperty.call(field, "name") ||
        Object.prototype.hasOwnProperty.call(field, "label") ||
        Object.prototype.hasOwnProperty.call(field, "value")
      ) {
        name = String(field?.name || "");
        label = String(field?.label || "");
        value = field?.value;

        if (value === undefined && name && field?.[name] !== undefined) {
          value = field[name];
        }
      } else {
        const firstEntry = Object.entries(field).find(
          ([key]) => !String(key).toLowerCase().includes("verified"),
        );

        if (!firstEntry) return;

        name = String(firstEntry[0]);
        value = firstEntry[1];
        label = toTitleLabel(name);
      }

      const referenceIndex = getReferenceIndex(name, label, 1);

      if (!grouped.has(referenceIndex)) grouped.set(referenceIndex, []);

      grouped.get(referenceIndex)!.push({
        label: label || toTitleLabel(name || `reference${referenceIndex}Field${index + 1}`),
        name: name || `reference${referenceIndex}Field${index + 1}`,
        value: value ?? "",
      });
    });

    return Array.from(grouped.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([idx, fields]) => {
        const validPrefixes = [`basicreference${idx}`, `addressreference${idx}`];
        const filteredFields = fields.filter((field: any) => {
          const fieldName = String(field?.name || "").toLowerCase();
          if (!fieldName) return true;
          return validPrefixes.some((prefix) => fieldName?.startsWith(prefix));
        });

        return {
          [`reference${idx}`]: filteredFields,
        };
      })
      .filter((item: any) => {
        const key = Object.keys(item || {})[0];
        return Array.isArray(item?.[key]) && item[key].length > 0;
      });
    };
  
  const buildCollateralSectionsFromRawFields = (rawFields: any[]): any[] => {
    if (!Array.isArray(rawFields) || rawFields.length === 0) return [];

    const grouped = new Map<number, { collateral: any[]; ownership: Map<string, any[]> }>();

    const ensureGroup = (idx: number) => {
      if (!grouped.has(idx)) {
        grouped.set(idx, { collateral: [], ownership: new Map() });
      }
      return grouped.get(idx)!;
    };

    const getCollateralIndex = (name: string, label: string, fallback: number): number => {
      const source = `${name} ${label}`.toLowerCase();
      // co-owner fields: coOwnerCollateral{N}_{M}...
      const coOwnerMatch = source.match(/coownercollateral(\d+)_/i);
      if (coOwnerMatch?.[1]) return Number(coOwnerMatch[1]);
      // plain collateral fields: collateral{N}...
      const collateralMatch = source.match(/collateral\s*(\d+)|collateral(\d+)/i);
      const detected = Number(collateralMatch?.[1] || collateralMatch?.[2]);
      return Number.isFinite(detected) && detected > 0 ? detected : fallback;
    };

    rawFields.forEach((field: any, index: number) => {
      if (!field || typeof field !== "object") return;

      let name = "";
      let label = "";
      let value: any = "";

      if (
        Object.prototype.hasOwnProperty.call(field, "name") ||
        Object.prototype.hasOwnProperty.call(field, "label") ||
        Object.prototype.hasOwnProperty.call(field, "value")
      ) {
        name = String(field?.name || "");
        label = String(field?.label || "");
        value = field?.value;
        if (value === undefined && name && field?.[name] !== undefined) {
          value = field[name];
        }
      } else {
        const firstEntry = Object.entries(field).find(
          ([key]) => !String(key).toLowerCase().includes("verified"),
        );
        if (!firstEntry) return;
        name = String(firstEntry[0]);
        value = firstEntry[1];
        label = toTitleLabel(name);
      }

      const collateralIndex = getCollateralIndex(name, label, 1);
      const group = ensureGroup(collateralIndex);
      const nameLower = name.toLowerCase();

      // co-owner fields go into ownership keyed by their group prefix e.g. coOwnerCollateral1_1
      const coOwnerGroupMatch = nameLower.match(/^(coownercollateral\d+_\d+)/i) || nameLower.match(/^(coownercollateral\d+)/i);
      if (coOwnerGroupMatch?.[1]) {
        const ownerKey = coOwnerGroupMatch[1];
        if (!group.ownership.has(ownerKey)) group.ownership.set(ownerKey, []);
        group.ownership.get(ownerKey)!.push({
          label: label || toTitleLabel(name),
          name,
          value: value ?? "",
        });
      } else {
        group.collateral.push({
          label: label || toTitleLabel(name || `collateral${collateralIndex}Field${index + 1}`),
          name: name || `collateral${collateralIndex}Field${index + 1}`,
          value: value ?? "",
        });
      }
    });

    return Array.from(grouped.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([idx, details]) => {
        const collateralPrefix = `collateral${idx}`;
        const filteredCollateral = details.collateral.filter((f: any) => {
          const fn = String(f?.name || "").toLowerCase();
          // "hasCollateral" doesn't start with "collateral<idx>" (it's a
          // standalone field, bucketed into group 1 by getCollateralIndex's
          // fallback above) — let it through instead of dropping it here.
          return !fn || fn === "hascollateral" || fn?.startsWith(collateralPrefix);
        });

        const ownershipPrefix = `coownercollateral${idx}_`;
        const filteredOwnership = Array.from(details.ownership.entries())
          .filter(([key]) => key?.startsWith(ownershipPrefix))
          .map(([key, fields]) => ({ [key]: fields }));

        return {
          [`collateral${idx}`]: {
            collateral: filteredCollateral,
            ownership: filteredOwnership,
          },
        };
      })
      .filter((item: any) => {
        const key = Object.keys(item || {})[0];
        const val = item?.[key];
        return (
          (Array.isArray(val?.collateral) && val.collateral.length > 0) ||
          (Array.isArray(val?.ownership) && val.ownership.length > 0)
        );
      });
  };
  function mergeVerticalStepFields(
    fields: Field[] | undefined
  ): Record<string, unknown> {
    const out: Record<string, unknown> = {};
    (fields || []).forEach((blob) => {
      if (blob && typeof blob === "object") {
        Object.entries(blob).forEach(([k, v]) => {
          out[k] = v;
        });
      }
    });
    return out;
  }
  function formatFlatFieldValue(v: unknown): string | number {
      if (v === null || v === undefined) return "";
      if (typeof v === "object" && v !== null) {
        const o = v as { label?: unknown; value?: unknown };
        if ("label" in o || "value" in o) {
          const lab = o.label != null ? String(o.label) : "";
          const val = o.value != null ? String(o.value) : "";
          return lab || val;
        }
      }
      if (typeof v === "boolean") return v ? "Yes" : "No";
      return v as string | number;
  }
  function fieldsToCollateralDetailsFromFlat(
    flat: Record<string, unknown>
  ): any[] {
    const indices = new Set<number>();
    Object.keys(flat).forEach((k) => {
      if (/^coOwnerCollateral\d+/i.test(k)) {
        const m = k.match(/^coOwnerCollateral(\d+)/i);
        if (m) indices.add(parseInt(m[1], 10));
      } else {
        const c = k.match(/^collateral(\d+)/i);
        if (c) indices.add(parseInt(c[1], 10));
      }
    });
    if (indices.size === 0) return [];

    // "hasCollateral" is a standalone field (not "collateral<N>...") so it
    // never matched the index-detection regexes above — attach it to
    // whichever group is lowest-numbered (mirroring how it's saved
    // alongside index 0 of whichever collateral group is saved first).
    const minIndex = Math.min(...Array.from(indices));
    const hasCollateralKey = Object.keys(flat).find(
      (k) => k.toLowerCase() === "hascollateral",
    );

    return Array.from(indices)
    .sort((x, y) => x - y)
      .map((n) => {
        const collateral: { name: string; label: string; value: string | number }[] =
          [];
        const ownershipFields: {
          name: string;
          label: string;
          value: string | number;
        }[] = [];

        if (n === minIndex && hasCollateralKey) {
          collateral.push({
            name: hasCollateralKey,
            label: toTitleLabel(hasCollateralKey),
            value: formatFlatFieldValue(flat[hasCollateralKey]),
          });
        }

        Object.keys(flat).forEach((k) => {
          const mo = k.match(new RegExp(`^coOwnerCollateral${n}(.+)$`, "i"));
          if (mo) {
            ownershipFields.push({
              name: k,
              label: toTitleLabel(mo[1]),
              value: formatFlatFieldValue(flat[k]),
            });
            return;
          }
          const mc = k.match(new RegExp(`^collateral${n}(.+)$`, "i"));
          if (mc) {
            collateral.push({
              name: k,
              label: toTitleLabel(mc[1]),
              value: formatFlatFieldValue(flat[k]),
            });
          }
        });

        const ownership =
          ownershipFields.length > 0
            ? [{ [`ownership${n}`]: ownershipFields }]
            : [];

        if (!collateral.length && !ownership.length) {
          return null;
        }
        return {
          [`collateral${n}`]: { collateral, ownership },
        };
      })
      .filter(Boolean) as any[];
  }
  const toTitleLabel = (str: string): string => {
    return str && str?.replace(/([A-Z])/g, " $1")
      // Capitalize the very first letter
      .replace(/^./, (match:any) => match.toUpperCase())
      .trim();
  };

  const convertRawFieldsToStructured = (rawFields: Record<string, any>[]): any[] => {
    if (!Array.isArray(rawFields)) return [];
    
    return rawFields
      .map((field) => {
        if (!field || typeof field !== "object") return null;

        const entries = Object.entries(field);
        if (entries.length === 0) return null;

        // FIX: entries[0] is [key, value]. Destructure them here:
        const [name, value] = entries[0];

        return {
          label: toTitleLabel(name),
          key: name,
          value: String(value ?? ""),
        };
      })
      .filter(Boolean); // Cleans out null entries
  };
  const renderContent = () => {
    if (isCustomTab && isLoanDetailsLoading) {
      return tabContentSkeleton();
    }
    if (isCustomTab) {
      if (isStudentDetailsTab) {
        return !studentDetails ? (
          tabContentSkeleton()
        ) : (
          <StudentDetailsTab
            studentDetails={studentDetails}
            isMobile={isMobile}
          />
        );
      } else if (isAddressDetailsTab) {
        return !addressDetails ? (
          tabContentSkeleton()
        ) : (
          <AddressDetailsTab
            addressDetails={addressDetails}
            isMobile={isMobile}
          />
        );
      } else if (isEmploymentDetailsTab) {
        return isLoanDetailsLoading || employmentDetails === undefined ? (
          tabContentSkeleton()
        ) : (
          <EmploymentDetailsTab
            employmentDetails={employmentDetails}
            companyAddressDetails={companyAddressDetails}
            isMobile={isMobile}
            designationsVal={designationsVal}
          />
        );
      } else if (isAcademicDetailsTab) {
        return !academicDetails ? (
          tabContentSkeleton()
        ) : (
          <AcademicDetailsTab
            academicDetails={academicDetails}
            isMobile={isMobile}
            educationGap={educationGap}
          />
        );
      } else if (isEntranceExamDetailsTab) {
        return !entranceDetails ? (
          tabContentSkeleton()
        ) : (
          <EntranceExamDetailsTab
            entranceDetails={entranceDetails}
            isMobile={isMobile}
          />
        );
      } else if (isLoanDetailsTab) {
        return !loanDetails ? (
          tabContentSkeleton()
        ) : (
          <LoanDetailsTab loanDetails={loanDetails} isMobile={isMobile} />
        );
      } else if (isExpenseDetailsTab) {
        const normalizedExpenseDetails:any = fetchUserApplicationData?.partnerStartedJourney===true ? expenseDetails:verticalStep?.fields ? convertRawFieldsToStructured(verticalStep?.fields) :[];
          if (normalizedExpenseDetails.length > 0) {
            return (
            <ExpenseDetailsTab
              expenseDetails={normalizedExpenseDetails}
              isMobile={isMobile}
            />
          );
        
        }
        if (fetchUserApplicationData?.partnerStartedJourney && isLoanDetailsLoading) {
          return tabContentSkeleton();
        }
      }
      else if (isApplicantAdditionalDetailsTab) {
        if (fetchUserApplicationData?.partnerStartedJourney) {
          // Partner-started journey: the "Applicant Details" section comes from
          // Student Details data (already fetched for the Student Details tab),
          // and the "Loan Details" section comes solely from the Processio API
          // (getLoanDetailsFromProcessio). If Processio has no data / failed,
          // the loan section stays blank rather than falling back to verticalStep.
          const applicantSectionLabelKeyMap: Record<string, string> = {
            "number of dependents": "applicantDependents",
            "nationality": "applicantNationality",
            "country of birth": "applicantBirthCountry",
            "city of birth": "applicantCityCountry",
            "maritial status": "applicantMaritalStatus",
            "marital status": "applicantMaritalStatus",
          };
          const applicantSectionFromStudentDetails = (
            Array.isArray(studentDetails) ? studentDetails : []
          )
            .map((field: any) => {
              const key =
                applicantSectionLabelKeyMap[
                  String(field?.label || "").trim().toLowerCase()
                ];
              if (!key) return null;
              return {
                key,
                name: key,
                label: toTitleLabel(key),
                value: String(field?.value ?? ""),
              };
            })
            .filter(Boolean);

          const loanSectionFromProcessio = appLoanDetails
            ? Object.entries(appLoanDetails).map(([key, value]) => ({
                key,
                name: key,
                label: toTitleLabel(key),
                value: String(value ?? ""),
              }))
            : [];

          const combinedDetails = [
            ...applicantSectionFromStudentDetails,
            ...loanSectionFromProcessio,
          ];

          if (combinedDetails.length > 0) {
            return (
              <ApplicantAdditionalTab
                applicantadditionalDetails={combinedDetails}
                isMobile={isMobile}
                maritalStatusMap={maritalStatusMap}
                isDIYJourney={!fetchUserApplicationData?.partnerStartedJourney}
              />
            );
          }
          if (isLoanDetailsLoading) {
            return tabContentSkeleton();
          }
          return (
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                No details available.
              </Typography>
            </Grid>
          );
        }

        const normalizedExpenseDetails = verticalStep?.fields ? convertRawFieldsToStructured(verticalStep?.fields) :[];

        if (normalizedExpenseDetails.length > 0) {
           return (
           <ApplicantAdditionalTab
             applicantadditionalDetails={normalizedExpenseDetails}
             isMobile={isMobile}
             maritalStatusMap={maritalStatusMap}
             isDIYJourney={!fetchUserApplicationData?.partnerStartedJourney}
           />
         );
        }
      }
      else if (isReferenceDetailsTab) {
        const normalizedReferenceDetails = Array.isArray(referenceDetails)
          ? referenceDetails
          : Array.isArray(referenceDetails?.ReferenceDetails)
            ? referenceDetails.ReferenceDetails
            : [];
        const fallbackReferenceDetails = buildReferenceSectionsFromRawFields(
          Array.isArray(verticalStep?.fields) ? verticalStep.fields : [],
        );
        const referenceSectionsToRender =
          normalizedReferenceDetails.length > 0
            ? normalizedReferenceDetails
            : fallbackReferenceDetails;

        if (normalizedVerticalStepName === normalizeKey("Reference Details")) {
          if (referenceSectionsToRender.length > 0) {
            return (
              <ReferenceDetailsTab
                referenceDetails={referenceSectionsToRender}
                isMobile={isMobile}
                pageTypeSummary={pageTypeSummary}
                partnerStartedJourny={fetchUserApplicationData?.partnerStartedJourney}
              />
            );
          }
        } else {
          const normalizedCollateralDetails = Array.isArray(collateralDetails)
            ? collateralDetails
            : Array.isArray(collateralDetails?.CollateralDetails)
              ? collateralDetails.CollateralDetails
              : [];
          const fallbackCollateralDetails = buildCollateralSectionsFromRawFields(
            Array.isArray(verticalStep?.fields) ? verticalStep.fields : [],
          );

          const flat = mergeVerticalStepFields(verticalStep?.fields);
          const colFromFields = fieldsToCollateralDetailsFromFlat(flat);
          const collateralSectionsToRender =
            normalizedCollateralDetails.length > 0
              ? normalizedCollateralDetails
              : colFromFields.length > 0
                ? colFromFields
                : fallbackCollateralDetails;
         
          if (referenceSectionsToRender.length > 0) {
            return (
              <>
                <ReferenceDetailsTab
                  referenceDetails={referenceSectionsToRender}
                  isMobile={isMobile}
                  pageTypeSummary={pageTypeSummary}
                   partnerStartedJourny={fetchUserApplicationData?.partnerStartedJourney}
                />
                <CollateralDetailsTab
                  collateralDetails={collateralSectionsToRender}
                  isMobile={isMobile}
                  pageTypeSummary={pageTypeSummary}
                  partnerStartedJourny={fetchUserApplicationData?.partnerStartedJourney}
                />
              </>
            );
          }
        }
      } 
      else if (isCollateralDetailsTab) {
        const normalizedCollateralDetails = Array.isArray(collateralDetails)
          ? collateralDetails
          : Array.isArray(collateralDetails?.CollateralDetails)
            ? collateralDetails.CollateralDetails
            : [];
        const fallbackCollateralDetails = buildCollateralSectionsFromRawFields(
          Array.isArray(verticalStep?.fields) ? verticalStep.fields : [],
        );
        const flat = mergeVerticalStepFields(verticalStep?.fields);
        const colFromFields = fieldsToCollateralDetailsFromFlat(flat);
        const collateralSectionsToRender =
          normalizedCollateralDetails.length > 0
            ? normalizedCollateralDetails
            : colFromFields.length > 0
              ? colFromFields
              : fallbackCollateralDetails;
       
        if (collateralSectionsToRender.length > 0) {
          return (
            <CollateralDetailsTab
              collateralDetails={collateralSectionsToRender}
              isMobile={isMobile}
              pageTypeSummary={pageTypeSummary}
              partnerStartedJourny={fetchUserApplicationData?.partnerStartedJourney}
            />
          );
        }else{
           return <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                No details available.
              </Typography>
            </Grid>
        }
      }
       else if (
        isProvideConsentDetailsTab &&
        fetchUserApplicationData?.partnerStartedJourney
      ) {
        return !partnerDetails ? (
          tabContentSkeleton()
        ) : (
          <ProvideConsentDetailsTab
            partnerDetails={partnerDetails?.applicantDetails}
            partnerApplicationDetails={partnerDetails?.applicationDetails}
            isMobile={isMobile}
          />
        );
      } else if (
        isProvideCourseDetailsTab &&
        fetchUserApplicationData?.partnerStartedJourney
      ) {
        return !partnerDetails ? (
          tabContentSkeleton()
        ) : (
          <ProvideCourseDetailsTab
            partnerDetails={partnerDetails?.applicationDetails}
            isMobile={isMobile}
          />
        );
      } else if (
        isProvideLoanDetailsTab &&
        fetchUserApplicationData?.partnerStartedJourney
      ) {
        return !partnerDetails ? (
          tabContentSkeleton()
        ) : (
          <ProvideLoanDetailsTab
            partnerDetails={partnerDetails?.applicationDetails}
            isMobile={isMobile}
          />
        );
      }
    }

    let formattedData = formatDataHelper(
      verticalStep?.fields,
      fetchUserApplicationData?.partnerStartedJourney,
      maritalStatusMap,
      resolveCityOfBirth
    );

    // Format order for Verify Yourself and Provide Consent
    if(formattedData && formattedData.length > 0){
      const isExist = formattedData.some((item: FormattedItem) => item?.label?.toLowerCase() === "product");
      if(isExist) {
       formattedData = getOrderedData(formattedData);
      }
    }

    if (formattedData?.length === 0) {
      return isLoanDetailsLoading ? (
        tabContentSkeleton()
      ) : (
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary">
            No details available.
          </Typography>
        </Grid>
      );
    }

    const skipLabels: string[] = [
      "University Country Id",
      "University Campus Id",
      "University Not In List",
      "Institute Code",
      "Institute Not In List",
      "Course Code",
      "Course Name Not In List",
    ];

    const rupeeFields: string[] = ["Loan Amount", "Total Cost", "Monthly Obligation"];
   
    return formattedData?.map((field: FormattedItem, subIndex: number) => {
      const fieldLabelLower = field?.label?.toLowerCase();
      const productValueMap: { [key: string]: string } = {
        SLI: "Student Loan International",
      };

      const shouldSkip = skipLabels.some(
        (label) => label?.toLowerCase() === fieldLabelLower
      );
      if (shouldSkip) return null;

      // Check if this label needs ₹ prefix and comma separation
      const isRupeeField = rupeeFields.some(
        (r) => r?.toLowerCase() === fieldLabelLower
      );

      const baseValue = field?.value;
      const mappedValue =
        fieldLabelLower === "product" && typeof baseValue === "string"
          ? productValueMap[baseValue.trim().toUpperCase()] ?? baseValue
          : baseValue;

      let updatedValue = mappedValue ?? "";
      if (isRupeeField && mappedValue != null) {
        const numericValue = Number(String(mappedValue).replace(/,/g, ""));
        
        if (!isNaN(numericValue)) {
          updatedValue = new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
            .format(numericValue)
            .replace("₹", "₹\u00A0");
        }
      }

      return (
        <Grid item xs={12} sm={6} md={4} key={subIndex}>
          <TypedDetailRow
            item={{
              ...field,
              value: updatedValue,
            }}
          />
        </Grid>
      );
    });
  };

  return (
    <Box>
      {isStudentDetailsTab && !isMobile && (
        <Typography
          sx={{
            pb: 3,
            fontSize: "13px",
            fontWeight: 600,
            color: "#6f6b7d",
          }}
        >
          {/* Verification & Consent Details */}
        </Typography>
      )}

      <Grid container rowSpacing={2} columnSpacing={isMobile ? 2 : 4}>
        {renderContent()}
      </Grid>
    </Box>
  );
};

// bottomsheet mobile inner view
const ApplicationDetailsTabs: React.FC<ApplicationDetailsTabsProps> = ({
  application,
  tabIndex: propTabIndex,
  handleChange: propHandleChange,
  title,
  completionRate,
  onClose,
  isLoanDetailsLoading,
  isXsOrSm,
  coApplicantDetails,
  coApplicantCompletionRate,
  designationsVal,
  maritalStatusMap,
  pageTypeSummary,
  onRemoveCoApplicant,

}) => {
  const activeTabIndex = propTabIndex;
  const activeHandleChange = propHandleChange;

  const defaultApplicantLoanDetailsTabs: VerticalStep[] = [
    { verticalStepName: "Student Details", fields: [] },
    { verticalStepName: "Address Details", fields: [] },
    { verticalStepName: "Employment Details", fields: [] },
    { verticalStepName: "Academic Details", fields: [] },
    { verticalStepName: "Entrance Exam Details", fields: [] },
    { verticalStepName: "Loan Details", fields: [] },
  ];
  const defaultAdditionalDetailsTabs: VerticalStep[] = [
    { verticalStepName: "Applicant Additional Details", fields: [] },
    { verticalStepName: "Funds & Expenses", fields: [] },
    { verticalStepName: "Reference Details", fields: [] },
    { verticalStepName: "Collateral Details", fields: [] },
  ];

  let innerDataToUse: VerticalStep[] = splitReferenceCollateralVerticalSteps(
    application?.innerData?.filter(
      (item) =>
        item?.verticalStepName?.toLowerCase() !==
        "co-applicant aditional details" &&
        item?.verticalStepName?.toLowerCase() !==
        "co-applicant details"
    ) || [],
  );
  const isCoApplicantSection = application?.label === "Co-Applicant";
  const shouldShowCoApplicantTabs =
    isCoApplicantSection && innerDataToUse.length === 0;

  const defaultStepsForSection = getDefaultVerticalStepsForSection(
    application?.label || "",
  );
  if (defaultStepsForSection.length > 0) {
    innerDataToUse = mergeVerticalStepsWithDefaults(
      innerDataToUse,
      defaultStepsForSection,
    );
  }
  return (
    <Box>
      {isXsOrSm && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box>
            <Typography
              sx={{ fontSize: "20px", fontWeight: 700, color: "#333" }}
            >
              {title}
            </Typography>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 400, color: "#949393ff" }}
            >
              {title} Related Details
            </Typography>
          </Box>

          {/* <Typography
            sx={{ fontSize: "15px", fontWeight: 500, color: "#00b3b5" }}
          >
            {isCoApplicantSection
              ? `${coApplicantCompletionRate}%`
              : completionRate}
          </Typography> */}
        </Box>
      )}

      <Box>
        {shouldShowCoApplicantTabs ? (
          !coApplicantDetails ? (
            referenceDetailsSkeleton()
          ) : (
            <CoApplicantTabs
              coApplicant={coApplicantDetails}
              onRemoveCoApplicant={onRemoveCoApplicant}
              designationsVal={designationsVal}
            />
          )
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "100%",
                ...(isXsOrSm
                  ? { overflowX: "auto", WebkitOverflowScrolling: "touch" }
                  : { borderBottom: 1, borderColor: "divider" }),
              }}
            >
              <InnerDetailsTabs
                innerData={innerDataToUse}
                activeTabIndex={activeTabIndex}
                activeHandleChange={activeHandleChange}
                isXsOrSm={isXsOrSm}
              />
            </Box>

            {innerDataToUse?.map((verticalStep: VerticalStep, i: number) => (
              <TabPanel value={activeTabIndex} index={i} key={i} isMobile={isXsOrSm}>
                <RenderTabContent
                  applicationLabel={application?.label}
                  verticalStep={verticalStep}
                  isMobile={isXsOrSm}
                  isLoanDetailsLoading={isLoanDetailsLoading}
                  designationsVal={designationsVal}
                  maritalStatusMap={maritalStatusMap}
                  pageTypeSummary={pageTypeSummary}
                />
              </TabPanel>
            ))}
          </>
        )}
      </Box>

      <Button
        variant="contained"
        sx={{
          width: "100%",
          backgroundColor: "#00b3b5",
          color: "#fff",
          "&:hover": { backgroundColor: "#00b3b5" },
          fontWeight: "600",
          fontSize: "14px",
          borderRadius: 2,
          textTransform: "capitalize",
          py: 1,
          mt: 1,
        }}
        onClick={onClose}
      >
        Close
      </Button>
    </Box>
  );
};

interface SummaryRowActionProps {
  rowActionLabel: string;
  clickable: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel?: () => void;
}

const SummaryRowAction: React.FC<SummaryRowActionProps> = ({
  rowActionLabel,
  clickable,
  onEdit,
  onSave,
  onCancel,
}) => {
  const summarySaveInProgress = useSelector(
    (state: RootState) => state?.stepper?.summarySaveInProgress
  );
  const [saveClicked, setSaveClicked] = useState(false);

  useEffect(() => {
    if (!summarySaveInProgress) {
      setSaveClicked(false);
    }
  }, [summarySaveInProgress]);

  const isSaving =
    rowActionLabel === "Save" && (saveClicked || summarySaveInProgress);

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!clickable || isSaving) return;

    if (rowActionLabel === "Save") {
      flushSync(() => {
        setSaveClicked(true);
      });
      onSave();
      return;
    }

    if (rowActionLabel === "Edit") {
      onEdit();
    }
  };

  const handleCancelClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (isSaving) return;
    onCancel?.();
  };

  const SKY_COLOR = "#00b3b5";

  if (rowActionLabel === "Save") {
    return (
      <Box sx={{ display: "inline-flex", alignItems: "center", gap: "12px" }}>
        <Button
          variant="contained"
          size="small"
          onClick={handleClick}
          disabled={!clickable || isSaving}
          startIcon={
            isSaving ? (
              <CircularProgress size={14} thickness={5} sx={{ color: "#fff" }} />
            ) : undefined
          }
          sx={{
            textTransform: "capitalize",
            fontWeight: 600,
            fontSize: "14px",
            backgroundColor: SKY_COLOR,
            "&:hover": { backgroundColor: SKY_COLOR, opacity: 0.9 },
            "&.Mui-disabled": {
              backgroundColor: SKY_COLOR,
              color: "#fff",
              opacity: 0.5,
            },
          }}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
        {onCancel && (
          <Button
            variant="outlined"
            size="small"
            onClick={handleCancelClick}
            disabled={isSaving}
            sx={{
              textTransform: "capitalize",
              fontWeight: 600,
              fontSize: "14px",
              color: SKY_COLOR,
              borderColor: SKY_COLOR,
              "&:hover": { borderColor: SKY_COLOR, backgroundColor: "rgba(14, 165, 233, 0.06)" },
              "&.Mui-disabled": {
                color: SKY_COLOR,
                borderColor: SKY_COLOR,
                opacity: 0.5,
              },
            }}
          >
            Cancel
          </Button>
        )}
      </Box>
    );
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        cursor: clickable ? "pointer" : "not-allowed",
        opacity: clickable ? 1 : 0.5,
        color: "#00b3b5",
        userSelect: "none",
        "&:hover": {
          opacity: clickable ? 0.8 : 0.5,
        },
      }}
    >
      {rowActionLabel === "Edit" && <EditIcon sx={{ fontSize: "18px" }} />}
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          textTransform: "capitalize",
        }}
      >
        {rowActionLabel}
      </Typography>
    </Box>
  );
};

// --- Main Component ---
const ApplicationDetails: React.FC<ApplicationDetailsProps> = ({ pageTypeSummary }) => {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  const [data, setData] = useState<CombinedStep[]>([]);
  const [percentageValue, setPercentageValue] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isBreDataFlag, setIsBreDataFlag] = useState(false);
  const [isViewProvisionalOfferModalOpen, setIsViewProvisionalOfferModalOpen] = useState(false);
  const [isOpenPendingModal, setOpenPendingModal] = useState(false);
  const [confirmRemoveOpen, setConfirmRemoveOpen] = useState(false);
  const [pendingRemoveCoApplicantNumber, setPendingRemoveCoApplicantNumber] =
    useState<number | null>(null);
  const [isLoanDetailsLoading, setIsLoanDetailsLoading] = useState(false);
  // Authoritative co-applicant count from the backend, used to keep "Add More"
  // disabled when a co-applicant exists server-side but hasn't shown up in the
  // fetched data yet (notably right after a page refresh — see
  // shouldDisableAddMoreCoApplicant above for why).
  const [coApplicantCountFromApi, setCoApplicantCountFromApi] = useState<
    number | null
  >(null);
  const fetchCoApplicantCountFromApi = async (currentTrackingId: any) => {
    if (!currentTrackingId) return;
    try {
      const countResp = await postsServices.addPost(
        "api/v1/applicant/get-coapplicant-count",
        { trackingId: currentTrackingId },
      );
      const apiCount = countResp?.data?.data?.count;
      if (typeof apiCount === "number") {
        setCoApplicantCountFromApi(apiCount);
      }
    } catch {
      // Leave whatever value we already had — a transient failure here
      // shouldn't suddenly re-enable Add More.
    }
  };
  const token: any = process.env.REACT_APP_FETCH_TOKEN;
  const applicationNumber = useSelector((state: RootState) => state.stepper.trackingId);
  const { isProvisionalOffer, fetchUserApplicationData } = useSelector((state: RootState) => state?.stepper);
  const provisionalOffer = useSelector((state: RootState) => state.stepper.breData);
  const [expandedSection, setExpandedSection] = useState<number | null>(0);
  const [tabIndex, setTabIndex] = useState(0);
  const { userProfile } = useSelector(authSelector);
  const {
    coApplicantDetails: reduxCoApplicantDetails,
    coApplicantCompletionRate,
    studentDetails,
  } = useSelector((state: RootState) => state?.applicationLoanDetailsData);
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(false);
  const [editingStep, setEditingStep] = useState<{
    appLabel?: string;
    verticalStepName?: string;
  } | null>(null);
  const reduxHorizontalSteps = useSelector(
    (state: RootState) => state?.stepper?.horizontalSteps ?? []
  );
  const summaryApplicationEditActive = useSelector(
    (state: RootState) => state?.stepper?.summaryApplicationEditActive
  );
  const summarySaveInProgress = useSelector(
    (state: RootState) => state?.stepper?.summarySaveInProgress
  );
  const skipNextSummaryRefetch = useSelector(
    (state: RootState) => state?.stepper?.skipNextSummaryRefetch
  );
  // Read via a ref (synced every render) rather than as an effect dependency below —
  // the effect itself resets this flag, and including it as a dependency would make
  // that reset re-trigger the same effect a second time (this time with the flag
  // already false), falling through to the very fetchData() call it's meant to skip.
  const skipNextSummaryRefetchRef = useRef(skipNextSummaryRefetch);
  skipNextSummaryRefetchRef.current = skipNextSummaryRefetch;
  const prevSummarySaveInProgressRef = useRef(summarySaveInProgress);
  const selectedProduct = useSelector(
    (state: RootState) => state?.stepper?.selectedProduct
  );
  const breData = useSelector((state: RootState) => state.stepper.breData);
  
  const horizontalStepsone = useSelector(
    (state: RootState) => state?.stepper?.horizontalSteps
  );
  const {
    templateId,
    applicationId,
    trackingId,
    isDocumentVerifiedCoApplicant,
    coApplicantZipCodeData,
    formData,
    coApplicantVerification,
    disableAddMoreCoApplicant,
    savedBasicCoApplicants,
    loanDetailCoApplicantCollapseValue,
    encryptionKey,
  } = useSelector((state: RootState) => state.stepper);
  const horizontalSteps = useSelector(
    (state: RootState) => state?.stepper?.horizontalSteps
  );
  useEffect(() => {
    fetchCoApplicantCountFromApi(trackingId);
  }, [trackingId]);
  const genderOptions = useMemo(() => {
    const genders = mapGender() as Array<{ code: string; name: string }>;
    return genders.map((g) => ({
      value: g.name.toLowerCase(),
      label: g.name,
    }));
  }, []);
  const mergedCoApplicantDetails = useMemo(
    () =>
      buildMergedCoApplicantDetails(horizontalStepsone || []),
    [horizontalStepsone],
  );
  const coApplicantDetails =
    fetchUserApplicationData?.partnerStartedJourney === false
      ? mergedCoApplicantDetails || reduxCoApplicantDetails
      : reduxCoApplicantDetails || mergedCoApplicantDetails;
  const coApplicantDetailsRef = useRef(coApplicantDetails);
  
  // Update ref if we have data
  if (coApplicantDetails) {
    coApplicantDetailsRef.current = coApplicantDetails;
  }
  // Use stable data to prevent unmounting
  let  stableCoApplicantDetails =
    coApplicantDetails || coApplicantDetailsRef.current;

  // it will reset opened tab/bottomsheet if device changes
  useEffect(() => {
    if (isXsOrSm) {
      setExpandedSection(null);
    } else {
      setIsBottomSheetOpen(false);
    }
  }, [isXsOrSm]);
  const [designations, setDesignations] = useState<any[]>([]);
  const [maritalStatusMap, setMaritalStatusMap] = useState<Record<string, string>>({});
  useEffect(() => {
    const fetchMaritalStatusMaster = async () => {
      try {
        const response = await dropdownService.getMaritalStatusMaster();
        const list = (response?.data || []) as any[];
        const map: Record<string, string> = {};
        list.forEach((item: any) => {
          const code = item?.maritalStatusCode ?? item?.code ?? item?.value;
          const desc = item?.maritalStatusName ?? item?.maritalStatusDesc ?? item?.desc ?? item?.label ?? item?.name;
          if (code != null && desc != null) {
            map[String(code).trim().toUpperCase()] = String(desc);
          }
        });
        setMaritalStatusMap(map);
      } catch (error) {
        console.error("Failed to fetch marital status master", error);
      }
    };
    fetchMaritalStatusMaster();
  }, []);
  useEffect(() => {
    const getCoApplicantCompletionRate = async () => {
      try {
        const res =
          await applicationDetailsServices.getCoApplicantCompletionRate(
            applicationNumber!
          );
        if (res?.data) {
          // dispatch(
          //   setCoApplicantCompletionRate(
          //     res.data?.copplicantCompletionRate || ""
          //   )
          // );
        }
      } catch (error) {
        console.error("Error fetching completion rate:", error);
      }
    };
    const fetchDesignations = async () => {
      try {
        const response = await eligibilityCheckServices.getDesignations();
        setDesignations(response?.data?.data || []);
      } catch (error) {
        console.error("Failed to fetch designations", error);
      }
    };
    if (applicationNumber) {
      getCoApplicantCompletionRate();
      if(fetchUserApplicationData?.partnerStartedJourney===false){
        fetchDesignations();
      }
      
    }
  }, [applicationNumber]);

  useEffect(() => {
    if (
      applicationNumber &&
      reduxHorizontalSteps.length === 0
    ) {
      dispatch(
        getFormJson({
          product: selectedProduct || "SLI",
          loaderShow: false,
          trackingId: applicationNumber,
        })
      );
    }
  }, [applicationNumber, dispatch, selectedProduct, reduxHorizontalSteps.length]);

  useEffect(() => {
    if (!summaryApplicationEditActive && editingStep) {
      setEditingStep(null);
      localStorage.removeItem("summaryEditingStep");
    }
  }, [summaryApplicationEditActive, editingStep]);

  // helper functions
  const CustomImageIcon: React.FC<{ src: string }> = ({ src }) => (
    <img src={src} alt="step icon" style={{ height: 24, width: 24 }} />
  );

  const stepIcons: { [key: string]: React.ElementType } = {
    "Eligibility Check": CustomImageIcon,
    "Applicant & Loan Details": CustomImageIcon,
    "Provisional Offer Letter": CustomImageIcon,
    "Co-Applicant": CustomImageIcon,
    "Additional Details & Documents": CustomImageIcon,
    "Final Verification & Sanction": CustomImageIcon,
    "Disbursement of Funds": CustomImageIcon,
  };

  const iconSrcMap: { [key: string]: string } = {
    "Eligibility Check": eligibilityCheckIcon,
    "Applicant & Loan Details": applicantAndLoanDetailsIcon,
    "Provisional Offer Letter": provisionalOfferLetterIcon,
    "Co-Applicant": coApplicantIcon,
    "Additional Details & Documents": addtionalDetailsAndDocumentsIcon,
    "Final Verification & Sanction": finalVerificationAndSanctionIcon,
    "Disbursement of Funds": DisbursementOfFundsIcon,
  };

  const memoizedIcons = React.useMemo(() => {
    const icons: { [key: string]: React.FC<any> } = {};
    Object.keys(stepIcons).forEach((label) => {
      const IconComponent = stepIcons[label] || DocumentIcon;
      const iconProps =
        IconComponent === CustomImageIcon ? { src: iconSrcMap[label] } : {};
      icons[label] = (props: any) => (
        <IconComponent {...iconProps} {...props} />
      );
    });
    return icons;
  }, []);

  const normalizeReferenceDetails = (referenceRaw: any[]): any[] => {
    if (!Array.isArray(referenceRaw) || referenceRaw.length === 0) return [];

    const grouped = new Map<number, any[]>();

    const getReferenceIndex = (name: string, label: string, fallback: number) => {
      const source = `${name} ${label}`.toLowerCase();
      const specificMatch = source.match(
        /(?:basic|address)reference\s*(\d+)|(?:basic|address)reference(\d+)/i,
      );
      if (specificMatch?.[1] || specificMatch?.[2]) {
        return Number(specificMatch[1] || specificMatch[2]);
      }

      const genericMatch = source.match(/reference\s*(\d+)|reference(\d+)/i);
      return Number(genericMatch?.[1] || genericMatch?.[2]) || fallback;
    };

    referenceRaw.forEach((section: any, sectionIndex: number) => {
      const sectionKey = Object.keys(section || {})[0];
      const sectionFields = Array.isArray(section?.[sectionKey])
        ? section[sectionKey]
        : [];

      sectionFields.forEach((field: any) => {
        const referenceIndex = getReferenceIndex(
          String(field?.name || ""),
          String(field?.label || ""),
          sectionIndex + 1,
        );

        if (!grouped.has(referenceIndex)) grouped.set(referenceIndex, []);
        grouped.get(referenceIndex)!.push(field);
      });
    });

    // Fallback: if everything got grouped into a single bucket,
    // split by repeated "Reference First Name" markers.
    if (grouped.size === 1) {
      const firstKey = Array.from(grouped.keys())[0];
      const allFields = grouped.get(firstKey) || [];

      const chunks: any[][] = [];
      let currentChunk: any[] = [];

      allFields.forEach((field: any) => {
        const source = `${field?.name || ""} ${field?.label || ""}`.toLowerCase();
        const isReferenceStart =
          /reference.*first\s*name|first\s*name.*reference/.test(source);

        if (isReferenceStart && currentChunk.length > 0) {
          chunks.push(currentChunk);
          currentChunk = [field];
        } else {
          currentChunk.push(field);
        }
      });

      if (currentChunk.length > 0) {
        chunks.push(currentChunk);
      }

      if (chunks.length > 1) {
        grouped.clear();
        chunks.forEach((chunk, idx) => {
          grouped.set(idx + 1, chunk);
        });
      }
    }

    if (grouped.size === 0) return referenceRaw;

    return Array.from(grouped.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([idx, fields]) => {
        const validPrefixes = [`basicreference${idx}`, `addressreference${idx}`];
        const filteredFields = fields.filter((field: any) => {
          const fieldName = String(field?.name || "").toLowerCase();
          if (!fieldName) return true;
          return validPrefixes.some((prefix) => fieldName?.startsWith(prefix));
        });

        return {
          [`reference${idx}`]: filteredFields,
        };
      })
      .filter((item: any) => {
        const key = Object.keys(item || {})[0];
        return Array.isArray(item?.[key]) && item[key].length > 0;
      });
  };

  const normalizeCollateralDetails = (collateralRaw: any[]): any[] => {
    if (!Array.isArray(collateralRaw) || collateralRaw.length === 0) return [];

    const grouped = new Map<number, { collateral: any[]; ownership: any[] }>();

    const ensureGroup = (idx: number) => {
      if (!grouped.has(idx)) {
        grouped.set(idx, { collateral: [], ownership: [] });
      }
      return grouped.get(idx)!;
    };

    const detectCollateralIndex = (field: any, fallback: number): number => {
      const source = `${field?.name || ""} ${field?.label || ""}`.toLowerCase();
      const match = source.match(/collateral\s*(\d+)|collateral(\d+)/i);
      const detected = Number(match?.[1] || match?.[2]);
      return Number.isFinite(detected) && detected > 0 ? detected : fallback;
    };

    collateralRaw.forEach((item: any, itemIndex: number) => {
      const itemKey = Object.keys(item || {})[0];
      const itemValue = item?.[itemKey] || {};

      const collateralFields = Array.isArray(itemValue?.collateral)
        ? itemValue.collateral
        : [];
      const ownershipItems = Array.isArray(itemValue?.ownership)
        ? itemValue.ownership
        : [];

      collateralFields.forEach((field: any) => {
        const idx = detectCollateralIndex(field, itemIndex + 1);
        ensureGroup(idx).collateral.push(field);
      });

      ownershipItems.forEach((ownerItem: any) => {
        const ownerKey = Object.keys(ownerItem || {})[0];
        const ownerFields = Array.isArray(ownerItem?.[ownerKey])
          ? ownerItem[ownerKey]
          : [];

        const idx = detectCollateralIndex(
          ownerFields?.[0] || { name: ownerKey, label: ownerKey },
          itemIndex + 1,
        );
        ensureGroup(idx).ownership.push({ [ownerKey]: ownerFields });
      });
    });

    // Fallback: if all collateral fields land in one group,
    // split by repeated "Collateral Type" markers.
    if (grouped.size === 1) {
      const firstKey = Array.from(grouped.keys())[0];
      const firstGroup = grouped.get(firstKey);
      const allCollateralFields = firstGroup?.collateral || [];
      const allOwnershipItems = firstGroup?.ownership || [];

      const collateralChunks: any[][] = [];
      let currentChunk: any[] = [];

      allCollateralFields.forEach((field: any) => {
        const source = `${field?.name || ""} ${field?.label || ""}`.toLowerCase();
        const isCollateralStart =
          /collateral.*type|type.*collateral/.test(source);

        if (isCollateralStart && currentChunk.length > 0) {
          collateralChunks.push(currentChunk);
          currentChunk = [field];
        } else {
          currentChunk.push(field);
        }
      });

      if (currentChunk.length > 0) {
        collateralChunks.push(currentChunk);
      }

      if (collateralChunks.length > 1) {
        grouped.clear();

        collateralChunks.forEach((chunk, idx) => {
          grouped.set(idx + 1, {
            collateral: chunk,
            ownership:
              allOwnershipItems.length === collateralChunks.length
                ? [allOwnershipItems[idx]]
                : idx === 0
                  ? allOwnershipItems
                  : [],
          });
        });
      }
    }

    if (grouped.size === 0) return collateralRaw;

    return Array.from(grouped.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([idx, details]) => {
        // Keep only collateral fields whose name starts with "collateral{idx}"
        const collateralPrefix = `collateral${idx}`;
        const filteredCollateral = details.collateral.filter((field: any) => {
          const fieldName = String(field?.name || "").toLowerCase();
          if (!fieldName) return true;
          return fieldName?.startsWith(collateralPrefix);
        });

        // Keep ownership fields that belong to this collateral index,
        // even when backend owner object key is generic (e.g. owner1).
        const ownershipPrefix = `coownercollateral${idx}_`;
        const filteredOwnership = details.ownership
          .map((ownerItem: any) => {
            const ownerKey = String(Object.keys(ownerItem || {})[0] || "");
            const ownerFields = Array.isArray(ownerItem?.[ownerKey])
              ? ownerItem[ownerKey]
              : [];

            const relevantOwnerFields = ownerFields.filter((field: any) => {
              const fieldName = String(field?.name || "").toLowerCase();
              if (!fieldName) return false;
              return fieldName?.startsWith(ownershipPrefix);
            });

            return relevantOwnerFields.length > 0
              ? { [ownerKey || `coOwnerCollateral${idx}_1`]: relevantOwnerFields }
              : null;
          })
          .filter(Boolean);

        return {
          [`collateral${idx}`]: {
            collateral: filteredCollateral,
            ownership: filteredOwnership,
          },
        };
      })
      .filter((item: any) => {
        const key = Object.keys(item || {})[0];
        const val = item?.[key];
        return (
          (Array.isArray(val?.collateral) && val.collateral.length > 0) ||
          (Array.isArray(val?.ownership) && val.ownership.length > 0)
        );
      });
  };

  const handleChange = async (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    if (editingStep) {
      handleCancelEdit();
    }
    setTabIndex(newValue);
    const selected = data[expandedSection ?? -1];

    // Only call APIs if partnerStartedJourney is true, applicantId !== null & applicationId !== null
    if (
      fetchUserApplicationData?.partnerStartedJourney &&
      fetchUserApplicationData?.applicantId &&
      fetchUserApplicationData?.applicationId
    ) {
      if (
        selected &&
        selected?.label === "Applicant & Loan Details" &&
        (fetchUserApplicationData?.applicantId ||
          fetchUserApplicationData?.applicationId)
      ) {
        setIsLoanDetailsLoading(true);
        try {
          if (newValue === 2) {
            const employmentRes =
              await applicationDetailsServices.getEmploymentDetails(
                fetchUserApplicationData?.applicantId || "",
                applicationNumber || ""
              );
            if (employmentRes && employmentRes.data) {
              const employmentData =
                employmentRes?.data?.data?.EmploymentDetails;
              // Check if data has valid structure (not just empty object {})
              const hasValidStructure =
                employmentData &&
                (employmentData.EmploymentDetails !== undefined ||
                  employmentData.CompanyAddressDetails !== undefined);

              dispatch(
                setEmploymentDetails(
                  hasValidStructure
                    ? employmentData
                    : {
                        EmploymentDetails: [],
                        CompanyAddressDetails: [],
                      }
                )
              );
            }
          } else if (newValue === 3) {
            const academicRes =
              await applicationDetailsServices.getAcademicDetails(
                fetchUserApplicationData?.applicationId || "",
                applicationNumber || ""
              );
            if (academicRes && academicRes.data) {
              const details =
                academicRes?.data?.data?.["Application&LoanDetails"]
                  ?.academicDetails || [];
              dispatch(
                setEducationGap(
                  academicRes?.data?.data?.["Application&LoanDetails"]
                    ?.educationGap || 0
                )
              );
              dispatch(setAcademicDetails({ academicDetails: details }));
            }
          } else if (newValue === 4) {
            const entranceRes =
              await applicationDetailsServices.getEntranceDetails(
                fetchUserApplicationData?.applicationId,
                fetchUserApplicationData?.applicantId || "",
                applicationNumber || ""
              );
            if (entranceRes && entranceRes?.data) {
              dispatch(setEntranceDetails(entranceRes?.data?.data));
            }
          } else if (newValue === 5) {
            // loan details logic
          }
        } catch (err) {
          console.error("Failed to fetch details", err);
        } finally {
          setIsLoanDetailsLoading(false);
        }
      }

      if (
        selected &&
        selected?.label === "Additional Details & Documents" &&
        (fetchUserApplicationData?.applicantId ||
          fetchUserApplicationData?.applicationId)
      ) {
        setIsLoanDetailsLoading(true);
        try {
          if(newValue === 1) {  
            const res = await applicationDetailsServices.getExpenseDetails(
              fetchUserApplicationData?.applicationId || "",
              applicationNumber || ""
            );
            if (res && res.data) {
              dispatch(setExpenseDetails(res?.data?.data?.ExpenseDetails));
            }
          }
          if (newValue === 2) {
            const referenceRes =
              await applicationDetailsServices.getReferenceDetails(
                fetchUserApplicationData?.applicationId || "",
                applicationNumber || ""
              );
            if (referenceRes && referenceRes?.data) {
              const normalizedReferenceDetails = referenceRes?.data?.data;
              // normalizeReferenceDetails(
              //   referenceRes?.data?.data?.ReferenceDetails || []
              // );

              dispatch(
                setReferenceDetails(
                  normalizedReferenceDetails
                )
              );
            }

          } else if (newValue === 3) {
            const collateralRes =
              await applicationDetailsServices.getCollateralDetails(
                fetchUserApplicationData?.applicationId || "",
                applicationNumber || ""
              );
            if (collateralRes && collateralRes?.data) {
              const normalizedCollateralDetails = collateralRes?.data?.data || [];
              // normalizeCollateralDetails(
              //   collateralRes?.data?.data || []
              // );
              dispatch(setCollateralDetails(normalizedCollateralDetails));
            }
          }
        } catch (err) {
          console.error("Failed to fetch reference details", err);
        } finally {
          setIsLoanDetailsLoading(false);
        }
      }
    }
  };

  const toggleSection = async (index: number) => {
    setExpandedSection(expandedSection === index ? null : index);
    const selected = data[index];
    setIsLoanDetailsLoading(true);

    try {
      // Only call APIs if partnerStartedJourney is true, applicantId !== null & applicationId !== null
      if (
        fetchUserApplicationData?.partnerStartedJourney &&
        fetchUserApplicationData?.applicantId &&
        fetchUserApplicationData?.applicationId
      ) {
        if (
          selected &&
          selected?.label === "Applicant & Loan Details" &&
          (fetchUserApplicationData?.applicantId ||
            fetchUserApplicationData?.applicationId)
        ) {
          const res =
            await applicationDetailsServices.getApplicationLoanDetails(
              fetchUserApplicationData?.applicantId || "",
              applicationNumber || ""
            );
          if (res && res.data) {
            dispatch(
              setApplicantLoanDetails(
                res?.data?.data?.["Application&LoanDetails"]
              )
            );
          }
        } else if (
          selected &&
          selected?.label === "Additional Details & Documents" &&
          (fetchUserApplicationData?.applicantId ||
            fetchUserApplicationData?.applicationId)
        ) {
          // const res = await applicationDetailsServices.getExpenseDetails(
          //   fetchUserApplicationData?.applicationId || "",
          //   applicationNumber || ""
          // );
          // if (res && res.data) {
          //   dispatch(setExpenseDetails(res?.data?.data?.ExpenseDetails));
          // }

          // "Applicant Details" (dependents, marital status, birth country, city, nationality)
          // inside Applicant Additional Details is sourced from Student Details data, so make
          // sure it's loaded even if the user never opened the "Applicant & Loan Details"
          // section first — otherwise a Processio failure leaves the whole tab blank.
          if (!studentDetails || studentDetails.length === 0) {
            try {
              const studentRes =
                await applicationDetailsServices.getApplicationLoanDetails(
                  fetchUserApplicationData?.applicantId || "",
                  applicationNumber || ""
                );
              if (studentRes && studentRes.data) {
                dispatch(
                  setApplicantLoanDetails(
                    studentRes?.data?.data?.["Application&LoanDetails"]
                  )
                );
              }
            } catch (studentErr) {
              console.error(
                "Failed to fetch student details for Applicant Additional Details",
                studentErr
              );
            }
          }

          try {
            const resone = await applicationDetailsServices.getAdditionalDetails(
              applicationNumber
            );
            if (resone && resone.data) {
              dispatch(setAppLoanDetails(resone?.data?.data));
            }
          } catch (processioErr) {
            console.error(
              "Failed to fetch loan details from Processio",
              processioErr
            );
          }
        }
      }
    } catch (e) {
      console.error("Failed to fetch section details", e);
    } finally {
      setIsLoanDetailsLoading(false);
    }
  };

  const onToggleHandler = (application: CombinedStep, appIndex: number) => {
    if (application?.label.toLowerCase() === "provisional offer letter") {
      return;
    }
    setTabIndex(0);
    toggleSection(appIndex);
    if (isXsOrSm && pageTypeSummary !== "loansummary") {
      setIsBottomSheetOpen(true);
    }
  };

  const handleCloseBottomSheet = () => {
    setIsBottomSheetOpen(false);
    setExpandedSection(null);
  };

  // --- BottomSheet Content ---
  const memoizedBottomSheetContent = useMemo(() => {
    const applicationData = data[expandedSection ?? -1];

    if (!isXsOrSm || !applicationData) {
      return null;
    }
  const handleRemoveCoApplicant = (coApplicantNumber: number) => {
    if (coApplicantNumber <= 1) return;
    setPendingRemoveCoApplicantNumber(coApplicantNumber);
    setConfirmRemoveOpen(true);
  };
    return (
      <ApplicationDetailsTabs
        application={applicationData}
        tabIndex={tabIndex}
        handleChange={handleChange}
        title={applicationData?.label}
        completionRate={applicationData?.completionRate}
        onClose={handleCloseBottomSheet}
        isLoanDetailsLoading={isLoanDetailsLoading}
        isXsOrSm={isXsOrSm}
        coApplicantDetails={stableCoApplicantDetails}
        coApplicantCompletionRate={coApplicantCompletionRate}
        designationsVal={designations}
        maritalStatusMap={maritalStatusMap}
        onRemoveCoApplicant={handleRemoveCoApplicant}
      />
    );
  }, [
    isXsOrSm,
    data,
    expandedSection,
    tabIndex,
    isLoanDetailsLoading,
    stableCoApplicantDetails,
    coApplicantCompletionRate,
  ]);

  // for progress calculation (any changes here, then make sure to check name based conditions)
  const applicationSteps = [
    { horizontalStepName: "Eligibility Check", verticalStepsCount: 3 },
    { horizontalStepName: "Applicant & Loan Details", verticalStepsCount: 6 },
    { horizontalStepName: "Provisional Offer Letter", verticalStepsCount: 0 },
    { horizontalStepName: "Co-Applicant", verticalStepsCount: 0 },
    {
      horizontalStepName: "Additional Details & Documents",
      verticalStepsCount: 6,
    },
    // {
    //   horizontalStepName: "Final Verification & Sanction",
    //   verticalStepsCount: 4,
    // },
    // { horizontalStepName: "Disbursement of Funds", verticalStepsCount: 8 },
  ];

  // Helper to get horizontal index from application label
  const getHorizontalIndexFromLabel = (label: string): number => {
    const index = applicationSteps.findIndex((step) => step.horizontalStepName === label);
    return index !== -1 ? index : 0;
  };
  const getHorizontalLabelFromIndex = (index: number): string => {
    // Check if the step exists at that index, otherwise default to the first step
    const step = applicationSteps[index] || applicationSteps[0];
    return step ? step.horizontalStepName : "";
  };

  const getEditorFields = (
    hStepKey: string,
    vIdx: string,
    specificVerticalStepName?: string,
  ) => {
    // 1. Find the specific horizontal step object matching the stepKey string
    const currentHorizontalStep = reduxHorizontalSteps?.find(
      (step:any) => step.stepLabel === hStepKey
    );
    const allVerticalSteps = currentHorizontalStep?.verticalSteps || [];

    // Reference/Collateral: the backend may send these as one combined step
    // or as two separate steps ("Reference Details" / "Collateral Details").
    // Gather whichever shape is present, then narrow to just the group
    // actually being edited — Reference Details must never carry Collateral
    // keys (and vice versa) into Formik values / the save payload, even when
    // the backend still sends them combined in one step (old shape).
    if (isReferenceCollateralVerticalStepLabel(vIdx)) {
      const relevantSteps = allVerticalSteps.filter((step: any) =>
        isReferenceCollateralVerticalStepLabel(step?.stepLabel || ""),
      );
      const byName = new Map<string, any>();
      relevantSteps.forEach((step: any) => {
        (step?.fields || []).forEach((field: any) => {
          if (!field?.name) return;
          byName.set(field.name, { ...byName.get(field.name), ...field });
        });
      });
      const merged = Array.from(byName.values());

      const normalizedSpecific = normalizeKey(specificVerticalStepName || "");
      const isReferenceKey = (name: any) => {
        const n = normalizeKey(name);
        return n.startsWith("basicreference") || n.startsWith("addressreference");
      };
      const isCollateralKey = (name: any) => {
        const n = normalizeKey(name);
        return (
          n.startsWith("collateral") ||
          n.startsWith("coownercollateral") ||
          n === "hascollateral"
        );
      };
      if (normalizedSpecific === normalizeKey("Reference Details")) {
        return merged.filter((field: any) => isReferenceKey(field?.name));
      }
      if (normalizedSpecific === normalizeKey("Collateral Details")) {
        return merged.filter((field: any) => isCollateralKey(field?.name));
      }
      return merged;
    }

    const verticalSteps = allVerticalSteps.find(
      (steps:any)=>steps?.stepLabel===vIdx
    );
    // 2. Drill down into its verticalSteps using the vertical index
    return verticalSteps?.fields ?? [];
  };
  const handleEditStep = (
    appLabel: string,
    verticalStepName: string,
    horizontalIndex: number,
    reduxVerticalIndex: number,
    uiVerticalIndex: number
  ) => {
    // Redux formData/isDocumentVerified (which the editor's "Verify Aadhaar"
    // button reads) can be stale from an earlier session/interaction and
    // never gets refreshed from the latest fetch on its own — sync it here,
    // from the same source the read-only Summary view already trusts, so
    // the editor can't show "Verified" when the API says otherwise.
    const applicantLoanDetailsStep = (
      fetchUserApplicationData?.horizontalSteps || []
    ).find((h: any) => h.horizontalStepName === "Applicant & Loan Details");
    const studentDetailsStep = (
      applicantLoanDetailsStep?.verticalSteps || []
    ).find((v: any) => v.verticalStepName?.trim() === "Student Details");
    const aadhaarVerifiedField = studentDetailsStep?.fields?.find(
      (field: any) => field && "isAadhaarVerified" in field,
    );
    const freshIsAadhaarVerified = aadhaarVerifiedField
      ? aadhaarVerifiedField.isAadhaarVerified === true ||
        aadhaarVerifiedField.isAadhaarVerified === "true"
      : false;
    dispatch(updateFormData({ isAadhaarVerified: freshIsAadhaarVerified }));
    dispatch(setIsDocumentVerified(freshIsAadhaarVerified));

    dispatch(setActiveHorizontalIndex(horizontalIndex));
    dispatch(setActiveVerticalIndex(reduxVerticalIndex));
    dispatch(setSummaryApplicationEditActive(true));
    setEditingStep({ appLabel, verticalStepName });
    setTabIndex(uiVerticalIndex);
    // Verify Aadhaar Number (inside FormEdit) redirects out to Digilocker and
    // back via a hard browser navigation, which remounts this page and loses
    // `editingStep` — persist it so the restore effect below can reopen the
    // same section instead of silently falling back to the read-only view.
    try {
      localStorage.setItem(
        "summaryEditingStep",
        JSON.stringify({
          appLabel,
          verticalStepName,
          horizontalIndex,
          reduxVerticalIndex,
          uiVerticalIndex,
        })
      );
    } catch {
      // ignore storage errors (e.g. private browsing)
    }
  };

  const handleCancelEdit = () => {
    setEditingStep(null);
    dispatch(setSummaryApplicationEditActive(false));
    localStorage.removeItem("summaryEditingStep");
  };

  // Restore an in-progress edit after returning from the Aadhaar Digilocker
  // redirect (?document_verified=true) — otherwise the section that was
  // being edited silently reverts to the read-only summary view.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("document_verified") !== "true") return;
    const raw = localStorage.getItem("summaryEditingStep");
    if (!raw) return;
    localStorage.removeItem("summaryEditingStep");
    try {
      const saved = JSON.parse(raw);
      if (saved?.appLabel && saved?.verticalStepName) {
        handleEditStep(
          saved.appLabel,
          saved.verticalStepName,
          saved.horizontalIndex,
          saved.reduxVerticalIndex,
          saved.uiVerticalIndex
        );
      }
    } catch {
      // ignore malformed/stale state
    }
    // Only ever needs to run once, right after this page mounts on return.
  }, []);

  function getCombinedApplicationSteps(
    selectedApp: Application,
    applicationSteps: {
      horizontalStepName: string;
      verticalStepsCount: number;
    }[]
  ): CombinedStep[] {
    const combinedSteps: CombinedStep[] = [];
    const hardcodedApplicantLoanTabs: VerticalStep[] = [
      { verticalStepName: "Student Details", fields: [] },
      { verticalStepName: "Address Details", fields: [] },
      { verticalStepName: "Employment Details", fields: [] },
      { verticalStepName: "Academic Details", fields: [] },
      { verticalStepName: "Entrance Exam Details", fields: [] },
      // { verticalStepName: "Loan Details", fields: [] },
    ];

    // if partnerstartedjourney is true then hide provisional offer from appliationsteps
    const isProvisionalOffer = (name: string) =>
      name?.toLowerCase() === "provisional offer letter";
    const filteredSteps =
      fetchUserApplicationData?.partnerStartedJourney === true
        ? applicationSteps?.filter(
            (s) => !isProvisionalOffer(s.horizontalStepName)
          )
        : applicationSteps;

    const staticStepsMap = new Map(
      filteredSteps?.map((step) => [
        step.horizontalStepName,
        step.verticalStepsCount,
      ])
    );

    // Set isEligible based on isEligibilityChecked for initial steps
    const getInitialIsEligible = (stepName: string) => {
      if (stepName === "Eligibility Check") {
        return selectedApp?.isEligibilityChecked === false ? false : 
               selectedApp?.isEligibilityChecked === null ? null : true;
      }
      return true; // Other steps default to true
    };

    for (const step of filteredSteps ?? []) {
      combinedSteps.push({
        label: step.horizontalStepName,
        completionRate: "0%",
        status:
          step.horizontalStepName === "Co-Applicant" &&
          coApplicantCompletionRate === 100
            ? "completed"
            : "pending",
        innerData: [],
        isEligible: getInitialIsEligible(step.horizontalStepName),
      });
    }
    if (selectedApp && selectedApp.horizontalSteps) {
      for (const dynamicStep of selectedApp.horizontalSteps) {
        const stepLabel = dynamicStep?.horizontalStepName;
        const staticVerticalStepsCount = staticStepsMap.get(stepLabel);

        if (staticVerticalStepsCount !== undefined) {
          const completionPercentage: any = dynamicStep?.completionRate ?? 0;

          const stepStatus =
            completionPercentage === 100 ? "completed" : "pending";
          const stepIndex = combinedSteps.findIndex(
            (step) => step?.label === stepLabel
          );

          if (stepIndex !== -1) {
            const shouldUseHardcodedApplicantLoanTabs =
              fetchUserApplicationData?.partnerStartedJourney === true &&
              stepLabel === "Applicant & Loan Details";

            const innerDataFromApi = shouldUseHardcodedApplicantLoanTabs
                ? hardcodedApplicantLoanTabs
                : dynamicStep?.verticalSteps || [];

            let mergedInnerData =
              stepLabel === "Additional Details & Documents"
                ? splitReferenceCollateralVerticalSteps(innerDataFromApi)
                : innerDataFromApi;

            // DIY / partnerStartedJourney=false: keep all default stage cards even if
            // backend returns only the stages that have data.
            if (fetchUserApplicationData?.partnerStartedJourney === false) {
              const defaults = getDefaultVerticalStepsForSection(stepLabel);
              if (defaults.length > 0) {
                mergedInnerData = mergeVerticalStepsWithDefaults(
                  mergedInnerData,
                  defaults,
                );
              }
            }

            combinedSteps[stepIndex] = {
              label: stepLabel,
              completionRate: `${completionPercentage}%`,
              status: stepStatus,
              innerData: mergedInnerData,
              isEligible: combinedSteps[stepIndex].isEligible, // Preserve isEligible
            };
          }
        }
      }
    }

    // DIY journey: ensure every section keeps its full default stage card list
    // even when backend returns only stages that already have data.
    if (fetchUserApplicationData?.partnerStartedJourney === false) {
      combinedSteps.forEach((step, idx) => {
        const defaults = getDefaultVerticalStepsForSection(step?.label || "");
        if (!defaults.length) return;
        combinedSteps[idx] = {
          ...step,
          innerData: mergeVerticalStepsWithDefaults(
            step?.innerData || [],
            defaults,
          ),
        };
      });
    }

    // Partner Journey Logic: If partner journey has begun, mark first 4 steps as completed and Final Verification as in-progress
    if (fetchUserApplicationData?.partnerStartedJourney === true) {
      const eligibilityIndex = combinedSteps.findIndex(
        (step) => step?.label === "Eligibility Check"
      );
      const applicantDetailsIndex = combinedSteps.findIndex(
        (step) => step?.label === "Applicant & Loan Details"
      );
      const provisionalOfferIndex = combinedSteps.findIndex(
        (step) => step?.label === "Provisional Offer Letter"
      );
      const additionalDetailsIndex = combinedSteps.findIndex(
        (step) => step?.label === "Additional Details & Documents"
      );
      const finalVerificationIndex = combinedSteps.findIndex(
        (step) => step?.label === "Final Verification & Sanction"
      );

      // Mark first 4 steps as completed (ticked)
      const stepsToComplete = [
        eligibilityIndex,
        applicantDetailsIndex,
        provisionalOfferIndex,
        additionalDetailsIndex
      ];

      stepsToComplete.forEach((stepIndex) => {
        if (stepIndex !== -1) {
          combinedSteps[stepIndex] = {
            ...combinedSteps[stepIndex],
            completionRate: "100%",
            status: "completed",
          };
        }
      });

      // Mark Final Verification & Sanction as in-progress
      if (finalVerificationIndex !== -1) {
        combinedSteps[finalVerificationIndex] = {
          ...combinedSteps[finalVerificationIndex],
          completionRate: "50%", // In-progress state
          status: "pending",
        };
      }
    }

    // isQualified Logic: If isQualified is true, mark Eligibility as complete and Applicant Details as in-progress
    if (selectedApp?.isQualified === true) {
      const eligibilityIndex = combinedSteps.findIndex(
        (step) => step?.label === "Eligibility Check"
      );
      
      const applicantDetailsIndex = combinedSteps.findIndex(
        (step) => step?.label === "Applicant & Loan Details"
      );

      // Mark Eligibility Check as completed (but only if not null)
      if (eligibilityIndex !== -1 && selectedApp?.isEligibilityChecked !== null) {
        combinedSteps[eligibilityIndex] = {
          ...combinedSteps[eligibilityIndex],
          completionRate: "100%",
          status: "completed",
          isEligible: true,
        };
      }

      // Mark Applicant Details as in-progress (only if not already completed)
      if (applicantDetailsIndex !== -1 && combinedSteps[applicantDetailsIndex].completionRate !== "100%") {
        combinedSteps[applicantDetailsIndex] = {
          ...combinedSteps[applicantDetailsIndex],
          status: "pending",
        };
      }
    }

    const eligibilityCheckStep = combinedSteps.find(
      (step) => step?.label === "Eligibility Check"
    );
    const applicantDetailsStep = combinedSteps.find(
      (step) => step?.label === "Applicant & Loan Details"
    );

    const areFirstTwoStepsCompleted =
      eligibilityCheckStep?.completionRate === "100%" &&
      applicantDetailsStep?.completionRate === "100%";

    // Mark Provisional Offer as complete based ONLY on isProvisionalGenerated flag
    if (selectedApp?.isProvisionalGenerated === true) {
      const provisionalOfferStepIndex = combinedSteps.findIndex(
        (step) => step?.label === "Provisional Offer Letter"
      );

      if (provisionalOfferStepIndex !== -1) {
        combinedSteps[provisionalOfferStepIndex] = {
          label: "Provisional Offer Letter",
          completionRate: "100%",
          status: "completed",
          innerData: [],
          isEligible: true,
        };
      }

      // Mark Additional Details as in-progress if not already completed
      const additionalDetailsIndex = combinedSteps.findIndex(
        (step) => step?.label === "Additional Details & Documents"
      );

      if (additionalDetailsIndex !== -1 && combinedSteps[additionalDetailsIndex].completionRate !== "100%") {
        combinedSteps[additionalDetailsIndex] = {
          ...combinedSteps[additionalDetailsIndex],
          status: "pending",
        };
      }
    }

    return combinedSteps;
  }

  const ProvisionalOfferModalContent = () => {
    const conditions = [
      "The In-principle sanction is provisional in nature, based on the information shared by you and is subject to revision basis verification of documents and further assessment/review.",
      "The In-principle sanction letter is subject to revision basis the credit underwriting norms, policies of Avanse and upon change in any information provided by you in the application form.",
      "The ROI / Processing Fees is subject to revision in terms of the final sanction letter /loan agreement basis verification of your profile / security or otherwise.",
      "The final sanction may be issued to you upon satisfactory (i) credit assessment (ii) KYC requirement (ii) Clearance of due diligence process (iii) payment of processing fees and (iv) your meeting the eligibility criteria set by Avanse Financial Services Ltd., under its credit policy.",
      "This In-principle sanction will automatically expire within 6 days from the date hereof and does not create any binding obligations on Avanse Financial Services Ltd., to sanction the loan and the same may be revoked or cancelled as per Avanse’s discretion.",
    ];

    const getRepaymentLabel = (type: string) => {
      let val= typeof type === "string"  ? type?.toUpperCase():type;
      switch (val) {
        case "PINT":
          return "Partial interest";
        case "SINT":
          return "Simple interest";
        case "EMI":
          return "EMI";
        default:
          return type || "-";
      }
    };

    return (
      <Box sx={{ background: "#fff", textAlign: "center" }}>
        {isProvisionalOffer ? (
          <>
            {isXsOrSm ? (
              <Box>
                <img
                  src={successProvisionalOffer}
                  alt="Provisional Letter Icon"
                  style={{
                    width: "80px",
                    height: "90px",
                    marginBottom: 16,
                  }}
                />
                <Typography
                  sx={{
                    fontWeight: "bold",
                    color: "#000",
                    mb: 1,
                    fontSize: "22px",
                  }}
                >
                  <span style={{ color: "#00B3B5" }}>Congratulations, </span>
                  {userProfile?.name}!
                </Typography>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-end",
                  gap: 5,
                }}
              >
                <img
                  src={leftConfetti}
                  alt="Confetti Left"
                  style={{ objectFit: "contain" }}
                />
                <Box>
                  <img
                    src={successProvisionalOffer}
                    alt="Provisional Letter Icon"
                    style={{
                      width: "80px",
                      height: "90px",
                      marginBottom: 16,
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#000",
                      mb: 1,
                      fontSize: "22px",
                    }}
                  >
                    <span style={{ color: "#00B3B5" }}>Congratulations, </span>
                    {userProfile?.name}!
                  </Typography>
                </Box>
                <img
                  src={rightConfetti}
                  alt="Confetti Right"
                  style={{ objectFit: "contain" }}
                />
              </Box>
            )}

            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#555",
                mb: 0.5,
              }}
            >
              You've received a Provisional Loan Offer from us!
            </Typography>
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#555",
                px: isXsOrSm ? 0 : 4,
              }}
            >
              Based on the information you've provided, we're excited to share
              this offer designed to support your academic journey.
            </Typography>
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#555",
                px: isXsOrSm ? 0 : 4,
              }}
            >
              To move forward, just complete your application.
              {/* <span
                style={{
                  fontSize: "13px",
                  fontWeight: "800",
                  color: "#cb9a0a",
                }}
              >
                and you'll receive your Sanction Letter within 48 hours.
              </span> */}
            </Typography>

            <Box
              sx={{
                p: 2,
                my: 2,
                borderRadius: "8px",
                background: "#f8f9fa",
                border: "1px solid #e9ecef",
              }}
            >
              <Typography
                sx={{
                  mb: 1,
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#495057",
                  fontFamily: "Jost, sans-serif",
                  lineHeight: "1.4",
                  textAlign: "left",
                }}
              >
                A quick glance at your loan offer details:
              </Typography>

              {isXsOrSm ? (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                  {[
                    { label: "Max Loan Amount:", 
                      value: provisionalOffer?.Max_Loan_Amount 
                      ? `₹ ${new Intl.NumberFormat('en-IN').format(Number(provisionalOffer.Max_Loan_Amount))}` 
                      : "₹ 0"
                    },
                    { label: "Currency:", value: provisionalOffer?.currency || "Rupees (₹)" },
                    { label: "Max Tenure:", value: provisionalOffer?.Max_Tenure || "0 Years" },
                    { label: "Repayment Mode:", value: getRepaymentLabel(provisionalOffer?.Repayment_Type) },
                  ].map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#6c757d",
                          fontFamily: "Jost, sans-serif",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#495057",
                          fontFamily: "Jost, sans-serif",
                          textAlign: "right",
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1,
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "50%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#6c757d",
                          fontFamily: "Jost, sans-serif",
                        }}
                      >
                        Max Loan Amount:{" "}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#495057",
                          fontFamily: "Jost, sans-serif",
                        }}
                      >
                        {provisionalOffer?.Max_Loan_Amount 
                          ? `₹ ${new Intl.NumberFormat('en-IN').format(Number(provisionalOffer.Max_Loan_Amount))}` 
                          : "₹ 0"
                        }
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "50%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#6c757d",
                          fontFamily: "Jost, sans-serif",
                        }}
                      >
                        Currency:{" "}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#495057",
                          fontFamily: "Jost, sans-serif",
                        }}
                      >
                        {provisionalOffer?.currency || "Rupees (₹)"}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      pt: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "50%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#6c757d",
                          fontFamily: "Jost, sans-serif",
                        }}
                      >
                        Max Tenure:{" "}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#495057",
                          fontFamily: "Jost, sans-serif",
                        }}
                      >
                        {provisionalOffer?.Max_Tenure || "0 Years"}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        width: "50%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#6c757d",
                          fontFamily: "Jost, sans-serif",
                        }}
                      >
                        Repayment Mode:{" "}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#495057",
                          fontFamily: "Jost, sans-serif",
                          textTransform: 'capitalize'
                        }}
                      >
                        {getRepaymentLabel(provisionalOffer?.Repayment_Type) || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>

            <Typography className="text5lable" sx={{ textAlign: "left" }}>
              Terms & Conditions
            </Typography>
            <List dense sx={{ listStyleType: "decimal", pl: 2 }}>
              {conditions.map((condition: string, index: number) => (
                <ListItem
                  key={index}
                  className="inner-form-heading3"
                  sx={{
                    display: "list-item",
                    alignItems: "flex-start",
                    mb: "0px !important",
                    py: "0px !important",
                  }}
                >
                  <ListItemText primary={condition} />
                </ListItem>
              ))}
            </List>
          </>
        ) : (
          <>
            {/* <Box
              component="img"
              src={failedProvisionalOffer}
              alt="Offer Status"
              sx={{ width: "80px", height: "90px", mb: 2 }}
            />
            <Typography
              sx={{
                fontWeight: "600",
                color: "#FF4C51",
                mb: 2,
                fontSize: "20px",
              }}
            >
              Thank you for completing the details. While we cannot provide an instant offer right now, your application is still being considered. 
              A Sales Manager will review your profile and contact you shortly to discuss available financing options.
            </Typography> */}

            <Typography
              sx={{
                mt: { xs: 0.5, sm: 1 },
                mb: { xs: 0.75, sm: 1.50 },
                fontSize: "26px",
                fontWeight: 600,
              }}
            >
              You're One Step Closer
            </Typography>
            {/* Congratulations Text */}
            <Typography
              sx={{
                mt: { xs: 0.5, sm: 1 },
                fontSize: "18px",
                fontWeight: 400,
              }}
            >
              To personalize your loan offer, we require a few additional details from you. Please proceed to complete the remaining sections of your application.
            </Typography>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 400,
              }}
            >
              Our Sales Manager will review your profile and contact you shortly to discuss the available financing options.
            </Typography>
          </>
        )}

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#00b3b5",
            color: "#fff",
            "&:hover": { backgroundColor: "#00b3b5" },
            fontWeight: "600",
            fontSize: "13px",
            px: 2.5,
            py: 1,
            borderRadius: 2,
            textTransform: "capitalize",
            mt: 1,
          }}
          onClick={() => setIsViewProvisionalOfferModalOpen(false)}
        >
          Close
        </Button>
      </Box>
    );
  };

  const PendingProvisionalOfferModalContent = () => {
    const handleOnContinuePendingProvision = () => {
      setOpenPendingModal(false);
    }

    return (
      <Box sx={{ background: "#fff", textAlign: "center" }}>
        <>
          <Box
            component="img"
            src={pendingProvisionalOffer}
            alt="Offer Status"
            sx={{ width: "80px", height: "90px", mb: 2 }}
          />
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: "700",
              color: "#000000",
              mb: 2,
            }}
          >
            Provisional Offer Pending
          </Typography>
          <Typography
            sx={{
              fontSize: "15px",
              fontWeight: "400",
              color: "#00000080",
              mb: 2,
            }}
          >
            Please resume your customer journey to get best offers.
          </Typography>
        </>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "#00b3b5",
            color: "#fff",
            "&:hover": { backgroundColor: "#00b3b5" },
            fontWeight: "600",
            fontSize: "13px",
            px: 2.5,
            py: 1,
            borderRadius: 2,
            textTransform: "capitalize",
            mt: 1,
          }}
          onClick={handleOnContinuePendingProvision}
        >
          Close
        </Button>
      </Box>
    );
  };

  // Any full-page refetch (save completion, Add More co-applicant, etc.)
  // briefly collapses the whole accordion list down to a handful of short
  // skeleton cards, which shrinks the page below the user's current scroll
  // position and forces the browser to clamp it back toward the top. These
  // two helpers snapshot both possible scroll containers — the page itself
  // (webview) and the mobile bottom sheet's own internal scroll area — right
  // before such a refetch, and restore them once the real content is back,
  // so the user stays on the same section instead of landing at the top.
  const snapshotScrollPositions = () => ({
    window: typeof window !== "undefined" ? window.scrollY : 0,
    sheet:
      document.getElementById("application-details-scroll-container")
        ?.scrollTop ?? 0,
  });
  const restoreScrollPositions = (snapshot: { window: number; sheet: number }) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: snapshot.window, behavior: "auto" });
        const sheetEl = document.getElementById(
          "application-details-scroll-container",
        );
        if (sheetEl) sheetEl.scrollTop = snapshot.sheet;
      });
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res: any = await fetchUserApplicationsFormData(
        token,
        applicationNumber
      );

      if (res.status === 200) {
        // Keep the redux `fetchUserApplicationData` snapshot (status, partnerStartedJourney, etc.)
        // in sync with the latest fetch — otherwise this page keeps showing whatever was last
        // dispatched by another page (e.g. Summary.tsx) instead of the current application status.
        if (res?.data?.applications?.[0]) {
          dispatch(setFetchUserApplicationData(res.data.applications[0]));
        }
        const finalSteps = getCombinedApplicationSteps(
          res?.data?.applications[0],
          applicationSteps
        );
       // setData(finalSteps);
        // Call summary completion API after successful fetch
        try {
          let value=await applicationDetailsServices.completeSummary(applicationNumber!);
          setData(mergeAndCalculateCompletion(finalSteps,value?.data?.data))
          setPercentageValue(value?.data?.data)
        } catch (err) {
          console.error("Error calling summary completion API:", err);
          setData(finalSteps);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const wasSaveInProgress = prevSummarySaveInProgressRef.current;
    prevSummarySaveInProgressRef.current = summarySaveInProgress;

    // Skip the refetch when a save is just starting (false -> true) — that
    // transition alone shouldn't flash the skeleton. Only refetch on initial
    // mount/navigation or once the save has actually finished (true -> false),
    // otherwise the skeleton flickers twice for a single save action.
    if (!wasSaveInProgress && summarySaveInProgress) {
      return;
    }

    // A validation guard (e.g. Reference Details) blocked the save and flipped
    // summarySaveInProgress back to false without actually saving anything —
    // skip the refetch so the section isn't torn down before the user can see
    // the inline error.
    if (skipNextSummaryRefetchRef.current) {
      dispatch(setSkipNextSummaryRefetch(false));
      return;
    }

    if (token && applicationNumber) {
      // Re-fetching after a save briefly collapses the whole accordion list
      // down to a handful of skeleton cards, which shrinks the page below
      // the user's current scroll position and forces the browser to clamp
      // it back toward the top. Snapshot both possible scroll containers —
      // the page itself (webview) and the mobile bottom sheet's own
      // internal scroll area — and restore them once the real content is
      // back, so the user stays on the same section instead of landing at
      // the top after the skeleton clears.
      const scrollSnapshot = snapshotScrollPositions();
      fetchData().then(() => restoreScrollPositions(scrollSnapshot));
    }
  }, [token, applicationNumber, summarySaveInProgress]);
  const navigate = useNavigate();
  const gotoDynamicForm = (stepName?: string) => {
    if (!stepName) {
      if(fetchUserApplicationData?.isProvisionalGenerated===true || fetchUserApplicationData?.horizontalSteps?.[3]?.verticalSteps[0]!=undefined){
        dispatch(setActiveHorizontalIndex(3));
        dispatch(setActiveVerticalIndex(1));
      }else{
        dispatch(setActiveHorizontalIndex(1));
        dispatch(setActiveVerticalIndex(5));
      }
      trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              page: "Existing Application_View Summary_Continue_coapplicant",
            }
      );
      navigate(ROUTES.Application.applyNow.locationPath);
      return;
    }
    switch (stepName) {
      case "Verify Yourself and Provide Consent":
        dispatch(setActiveHorizontalIndex(0));
        dispatch(setActiveVerticalIndex(0));
        break;
      case "Provide Course Details":
         trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_COURSE_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_COURSE_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_COURSE_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_COURSE_DETAILS",
              page: "Existing Application_View Summary_Continue_coursedetails",
            }
          );
        dispatch(setActiveHorizontalIndex(0));
        dispatch(setActiveVerticalIndex(1));
        break;
      case "Provide Loan Details":
         trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              page: "Existing Application_View Summary_Continue_loandetails",
            }
          );
        dispatch(setActiveHorizontalIndex(0));
        dispatch(setActiveVerticalIndex(2));
        break;
      case "Student Details":
          trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_STUDENT_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_STUDENT_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_STUDENT_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_STUDENT_DETAILS",
              page: "Existing Application_View Summary_Continue_studentdetails",
            }
          );
        dispatch(setActiveHorizontalIndex(1));
        dispatch(setActiveVerticalIndex(0));
        break;
      case "Address Details":
         trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_ADDRESS_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_ADDRESS_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_ADDRESS_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_ADDRESS_DETAILS",
              page: "Existing Application_View Summary_Continue_addressdetails",
            }
          );
        dispatch(setActiveHorizontalIndex(1));
        dispatch(setActiveVerticalIndex(1));
        break;
      case "Employment Details":
        trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_EMPLOYMENT_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_EMPLOYMENT_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_EMPLOYMENT_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_EMPLOYMENT_DETAILS",
              page: "Existing Application_View Summary_Continue_employmentdetails",
            }
          );
        dispatch(setActiveHorizontalIndex(1));
        dispatch(setActiveVerticalIndex(2));
        break;
      case "Academic Details":
        trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_ACADEMIC_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_ACADEMIC_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_ACADEMIC_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_ACADEMIC_DETAILS",
              page: "Existing Application_View Summary_Continue_academicdetails",
            }
          );
        dispatch(setActiveHorizontalIndex(1));
        dispatch(setActiveVerticalIndex(3));
        break;
      case "Entrance Exam Details":
        trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_ENTRANCE_EXAMS_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_ENTRANCE_EXAMS_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_ENTRANCE_EXAMS_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_ENTRANCE_EXAMS_DETAILS",
              page: "Existing Application_View Summary_Continue_entranceexamsdetails",
            }
          );
        dispatch(setActiveHorizontalIndex(1));
        dispatch(setActiveVerticalIndex(4));
        break;
      case "Co-Applicant Details":
        trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_lOAN_DETAILS",
              page: "Existing Application_View Summary_Continue_loandetails",
            }
          );
        dispatch(setActiveHorizontalIndex(1));
        dispatch(setActiveVerticalIndex(5));
        break;
      case "Applicant Additional Details":
      case "Additional Applicant Details":
        trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_APPLICANT_ADDITIONAL_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_APPLICANT_ADDITIONAL_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_APPLICANT_ADDITIONAL_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_APPLICANT_ADDITIONAL_DETAILS",
              page: "Existing Application_View Summary_Continue_applicantadditionaldetails",
            }
          );
        dispatch(setActiveHorizontalIndex(3));
        dispatch(setActiveVerticalIndex(0));
        break;
      case "Co-Applicant Additional Details":
      case "Co-Applicant Aditional Details":
         trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_COAPPLICANT_DETAILS",
              page: "Existing Application_View Summary_Continue_coapplicant",
            }
          );
        dispatch(setActiveHorizontalIndex(3));
        dispatch(setActiveVerticalIndex(1));
        break;
      case "Funds and Expenses":
      case "Funds & Expenses":
        trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_FUNDS_AND_EXPENSE_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_FUNDS_AND_EXPENSE_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_FUNDS_AND_EXPENSE_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_FUNDS_AND_EXPENSE_DETAILS",
              page: "Existing Application_View Summary_Continue_Funds&Expensedetails",
            }
          );
        dispatch(setActiveHorizontalIndex(3));
        dispatch(setActiveVerticalIndex(2));
        break;
      case "Reference & Collateral Details":
      case "Reference Details":
      case "Collateral Details":
        trackCustomerJourneyEvent(
            "EXT_SUMMARY_CONTINUE_REFERENCE_AND_COLLATERAL_DETAILS",
            decrypt(userProfile?.id) ?? "",
            trackingId,
            {
              label: "EXT_SUMMARY_CONTINUE_REFERENCE_AND_COLLATERAL_DETAILS",
              category: "EXT_SUMMARY_CONTINUE_REFERENCE_AND_COLLATERAL_DETAILS",
              action: "EXT_SUMMARY_CONTINUE_REFERENCE_AND_COLLATERAL_DETAILS",
              page: "Existing Application_View Summary_Continue_Referenced&Collateraldetails",
            }
          );
        dispatch(setActiveHorizontalIndex(3));
        dispatch(setActiveVerticalIndex(3));
        break;
      default:
        dispatch(setActiveHorizontalIndex(1));
        dispatch(setActiveVerticalIndex(5));
        break;
    }

    navigate(ROUTES.Application.applyNow.locationPath);
  };
  const payPartyOptions =["Yes","No"];
  const isEmployedOptions=["Yes","No"];
  const currentOwnershipStatusOptions=["Rented", "Owned"];
  const permanentOwnershipStatusOptions=["Rented", "Owned"];
  const employmentTypeOptions= ["Farmer", "Salaried", "SEP", "SENP", "Others"];
  // Get the vertical step id
  const verticalStepId = 9;//currentVerticalStep?.id;
  const addCoApplicantFields = async () => {
    // Only used as a fallback if the add fails before the new co-applicant's
    // own section ever renders (see the success path below) — on success,
    // that section scrolls itself into view instead.
    const scrollSnapshot = snapshotScrollPositions();
    setIsLoading(true);
      // Fetch current co-applicant count from API and use count+1 as the next number
      let nextCoApplicantNum = 0;
      try {
        const countResp = await postsServices.addPost(
          "api/v1/applicant/get-coapplicant-count",
          { trackingId }
        );
        const apiCount = countResp?.data?.data?.count;
        if (typeof apiCount !== "number") {
          // dispatch(
          //   setStatusPopup({
          //     status: "error",
          //     message: "Unable to fetch co-applicant count. Please try again.",
          //   })
          // );
          // return;
        }
         nextCoApplicantNum = apiCount === 0 ? 2 : apiCount + 1;
        nextCoApplicantNum = apiCount + 1;
        //setExpanded(`CoApplicant${nextCoApplicantNum}`);
        localStorage.setItem("coAppExpandedKey", `CoApplicant${nextCoApplicantNum}`);
        // Picked up by CoApplicantTabs once the newly added section renders,
        // so the customer doesn't have to scroll down and click Edit again —
        // it opens straight into edit mode. Namespaced by trackingId (not
        // just a bare key) so a leftover value can never apply to a
        // different application, and cleared in the catch block below if
        // this add fails, so a failed attempt can't leave it dangling
        // indefinitely and force an unrelated, already-saved co-applicant
        // into edit mode on some future page load.
        localStorage.setItem(`coAppAutoEditKey_${trackingId}`, String(nextCoApplicantNum));
       // dispatch(setDisableAddMoreCoApplicant(true));
      const apiFields = [
        // Basic Details
        {
          label: "Relationship with Student",
          name: `basicCoApplicant${nextCoApplicantNum}RelationWithStudent`,
          type: "autocomplete",
          required: true,
          //options: { options:relationshipOptions },
        },
        {
          label: "Specify Relationship",
          name: `basicCoApplicant${nextCoApplicantNum}OtherRelationWithStudent`,
          required: false,
          type: "text",
          options: null,
        },
        {
          label: "How should we address you? (Mr./Ms./etc.)",
          name: `basicCoApplicant${nextCoApplicantNum}salutation`,
          type: "dropdown",
          required: true,
          options: {
           // options: salutationOptionsList,
          },
        },
        {
          label: "Co-Applicant First Name",
          name: `basicCoApplicant${nextCoApplicantNum}FirstName`,
          type: "text",
          required: true,
        },
        {
          label: "Co-Applicant Last Name",
          name: `basicCoApplicant${nextCoApplicantNum}LastName`,
          type: "text",
          required: true,
        },
        {
          label: "Gender",
          name: `basicCoApplicant${nextCoApplicantNum}Gender`,
          type: "dropdown",
          options: { options: genderOptions },
          required: true,
        },
        {
          label: "Date of Birth",
          name: `basicCoApplicant${nextCoApplicantNum}dob`,
          type: "date",
          required: true,
        },
        {
          label: "PAN Number",
          name: `basicCoApplicant${nextCoApplicantNum}PanNumber`,
          type: "text",
          required: true,
        },
        {
          label: "Co-applicant mobile number",
          name: `basicCoApplicant${nextCoApplicantNum}PhoneNumber`,
          type: "phone",
          required: true,
        },
        {
          label: "Co-applicant email id",
          name: `basicCoApplicant${nextCoApplicantNum}Email`,
          type: "email",
          required: true,
        },
        {
          label: "PAN Verified",
          name: `basicCoApplicant${nextCoApplicantNum}IsPanVerified`,
          type: "boolean",
          required: false,
        },
        {
          label: "Mobile Verified",
          name: `basicCoApplicant${nextCoApplicantNum}IsMobileVerified`,
          type: "boolean",
          required: false,
        },
        {
          label: "Email Verified",
          name: `basicCoApplicant${nextCoApplicantNum}IsEmailVerified`,
          type: "boolean",
          required: false,
        },
        {
          label: "Nationality",
          name: `basicCoApplicant${nextCoApplicantNum}Nationality`,
          type: "autocomplete",
          required: true,
          //options:nationalityOptions,
        },
        {
          label: "Marital Status",
          name: `basicCoApplicant${nextCoApplicantNum}MaritalStatus`,
          type: "dropdown",
          required: true,
          //options: { options: maritalStatusOptions },
        },
        {
          label: "Country of Birth",
          name: `basicCoApplicant${nextCoApplicantNum}CountryOfBirth`,
          type: "autocomplete",
          required: true,
        },
        {
          label: "City of Birth",
          name: `basicCoApplicant${nextCoApplicantNum}CityOfBirth`,
          type: "autocomplete",
          required: true,
        },
        {
          label: "Aadhaar Verified",
          name: `basicCoApplicant${nextCoApplicantNum}AadhaarVerified`,
          type: "boolean",
          required: false,
        },
        {
          label:
            "Do you want to consider income of the co-applicant for loan evaluation?",
          name: `basicCoApplicant${nextCoApplicantNum}PayParty`,
          type: "radio",
          required: true,
          options: { options: payPartyOptions },
        },

        // Address Details (Permanent and Current)
        {
          label: "Owner Ship Status",
          name: `addressCoApplicant${nextCoApplicantNum}permanentOwnershipStatus`,
          type: "dropdown",
          required: true,
          options: { options: permanentOwnershipStatusOptions },
        },
        {
          label: "How long have you been living here?",
          name: `addressCoApplicant${nextCoApplicantNum}permanentYearsInCurrentAddress`,
          type: "number",
          required: true,
        },
        {
          label: "How long have you lived in this city ",
          name: `addressCoApplicant${nextCoApplicantNum}permanentYearsInCurrentCity`,
          type: "number",
          required: true,
        },
        {
          label: "Address Line 1",
          name: `addressCoApplicant${nextCoApplicantNum}permanentAddressLine1`,
          type: "text",
          required: true,
        },
        {
          label: "Address Line 2",
          name: `addressCoApplicant${nextCoApplicantNum}permanentAddressLine2`,
          type: "text",
          required: false,
        },
        {
          label: "Address Line 3",
          name: `addressCoApplicant${nextCoApplicantNum}permanentAddressLine3`,
          type: "text",
          required: false,
        },
        {
          label: "Pincode",
          name: `addressCoApplicant${nextCoApplicantNum}permanentPincode`,
          type: "text",
          required: true,
        },
        {
          label: "City",
          name: `addressCoApplicant${nextCoApplicantNum}permanentCity`,
          type: "autocomplete",
          required: true,
        },
        {
          label: "State",
          name: `addressCoApplicant${nextCoApplicantNum}permanentState`,
          type: "autocomplete",
          required: true,
        },
        {
          label: "Country",
          name: `addressCoApplicant${nextCoApplicantNum}permanentCountry`,
          type: "autocomplete",
          required: true,
        },
        {
          label: "Keep Current Address same as Permanent Address",
          name: `addressCoApplicant${nextCoApplicantNum}currentsameAsPermanent`,
          type: "checkbox",
          required: false,
        },
        {
          label: "Owner Ship Status",
          name: `addressCoApplicant${nextCoApplicantNum}currentOwnershipStatus`,
          type: "dropdown",
          required: true,
          options: { options: currentOwnershipStatusOptions },
        },
        {
          label: "How long have you been living here?",
          name: `addressCoApplicant${nextCoApplicantNum}currentYearsInCurrentAddress`,
          type: "text",
          required: true,
        },
        {
          label: "How long have you lived in this city",
          name: `addressCoApplicant${nextCoApplicantNum}currentYearsInCurrentCity`,
          type: "text",
          required: true,
        },
        {
          label: "Address Line 1",
          name: `addressCoApplicant${nextCoApplicantNum}currentAddressLine1`,
          type: "text",
          required: true,
        },
        {
          label: "Address Line 2",
          name: `addressCoApplicant${nextCoApplicantNum}currentAddressLine2`,
          type: "text",
          required: false,
        },
        {
          label: "Address Line 3",
          name: `addressCoApplicant${nextCoApplicantNum}currentAddressLine3`,
          type: "text",
          required: false,
        },
        {
          label: "Pincode",
          name: `addressCoApplicant${nextCoApplicantNum}currentPincode`,
          type: "text",
          required: true,
        },
        {
          label: "City",
          name: `addressCoApplicant${nextCoApplicantNum}currentCity`,
          type: "autocomplete",
          required: true,
        },
        {
          label: "State",
          name: `addressCoApplicant${nextCoApplicantNum}currentState`,
          type: "autocomplete",
          required: true,
        },
        {
          label: "Country",
          name: `addressCoApplicant${nextCoApplicantNum}currentCountry`,
          type: "autocomplete",
          required: true,
        },

        // Employment Details
        {
          label: "Are you employed?",
          name: `employmentCoApplicant${nextCoApplicantNum}isEmployed`,
          type: "radio",
          required: true,
          options: { options: isEmployedOptions },
        },
        {
          label: "Employment Type",
          name: `employmentCoApplicant${nextCoApplicantNum}employmentType`,
          type: "dropdown",
          required: true,
          options: { options: employmentTypeOptions },
        },
        {
          label: "Monthly Obligation",
          name: `employmentCoApplicant${nextCoApplicantNum}monthlyObligation`,
          type: "number",
          required: false,
        },
        {
          label: "Company Name",
          name: `employmentCoApplicant${nextCoApplicantNum}companyName`,
          type: "text",
          required: false,
        },
        {
          label: "Designation",
          name: `employmentCoApplicant${nextCoApplicantNum}designation`,
          type: "autocomplete",
          required: false,
        },
        {
          label: "Monthly Income",
          name: `employmentCoApplicant${nextCoApplicantNum}monthlyIncome`,
          type: "number",
          required: false,
        },
        {
          label: "Year",
          name:  `employmentCoApplicant${nextCoApplicantNum}employmentYear`,
          required: false,
          type: "number"
        },
        {
          label: "Month", 
          name:`employmentCoApplicant${nextCoApplicantNum}employmentMonth`, 
          type: "number", 
          required: false, 
        },
        // ── Company Address — FIX 8: using companyField helper ──
        {
          label: "Address Line 1",
          name: `employmentCoApplicant${nextCoApplicantNum}companyAddress1`,
          type: "text",
          required: false,
        },
        {
          label: "Address Line 2",
          name: `employmentCoApplicant${nextCoApplicantNum}companyAddress2`,
          type: "text",
          required: false,
        },
        {
          label: "Address Line 3",
          name: `employmentCoApplicant${nextCoApplicantNum}companyAddress3`,
          type: "text",
          required: false,
        },
        {
          label: "Landmark",
          name: `employmentCoApplicant${nextCoApplicantNum}landmark`,
          type: "text",
          required: false,
        },
        {
          label: "Pincode",
          name: `employmentCoApplicant${nextCoApplicantNum}pincode`,
          type: "number",
          required: false,
        },
        {
          label: "City",
          name:`employmentCoApplicant${nextCoApplicantNum}city`,
          type: "text",
          required: false,
        },
        {
          label: "State",
          name: `employmentCoApplicant${nextCoApplicantNum}state`,
          type: "text",
          required: false,
        },
        {
          label: "Country",
          name: `employmentCoApplicant${nextCoApplicantNum}companyCountry`,
          type: "autocomplete",
          required: false,
        },

      ];
      const resp = await postsServices.addPost(
        "api/v1/product/store-user-fields",
        {
          vertical_step_id: verticalStepId,
          trackingId: trackingId,
          fields: apiFields,
        }
      );
      if (resp?.data?.status === "success" && Array.isArray(resp?.data?.data)) {
        const newFields = resp.data.data.map((f: any) => ({
          ...f,
          options: f?.options ? f?.options : null,
        }));
        // --- PUSH new fields into the correct vertical step (id: 9, Loan Details) in applicant_loan horizontal step in Redux state ---
        const state = store.getState();
        if (
          state &&
          state.stepper &&
          Array.isArray(state.stepper.horizontalSteps)
        ) {
          const horizontalSteps = [...state.stepper.horizontalSteps];

          const applicantLoanStepIdx = horizontalSteps.findIndex(
            (step: any) => step.stepKey === "applicant_loan"
          );

          if (applicantLoanStepIdx !== -1) {
            const applicantLoanStep = {
              ...horizontalSteps[applicantLoanStepIdx],
            };
            const verticalSteps = [...applicantLoanStep.verticalSteps];
            let targetVerticalIdx = CO_APPLICANT_SOURCE_STEPS?.[0]?.verticalIndex;
            if (
              !Number.isInteger(targetVerticalIdx) ||
              targetVerticalIdx < 0 ||
              targetVerticalIdx >= verticalSteps.length
            ) {
              targetVerticalIdx = verticalSteps.findIndex(
                (step: any) =>
                  String(step?.verticalStepName || "").trim().toLowerCase() ===
                  "co-applicant details",
              );
            }
            if (
              typeof targetVerticalIdx === "number" &&
              targetVerticalIdx >= 0 &&
              targetVerticalIdx < verticalSteps.length
            ) {
              const targetStep = { ...verticalSteps[targetVerticalIdx] };
              targetStep.fields = [...targetStep.fields, ...newFields];
              verticalSteps[targetVerticalIdx] = targetStep;
              applicantLoanStep.verticalSteps = verticalSteps;
              horizontalSteps[applicantLoanStepIdx] = applicantLoanStep;
              // Dispatch redux update using setHorizontalSteps action creator
              dispatch(setHorizontalSteps(horizontalSteps));
            }
          }
        }
        await dispatch(
          getFormJson({
            product: selectedProduct || "SLI",
            loaderShow: false,
            trackingId,
          }),
        );
        // The newly added co-applicant's own effect (CoApplicantTabs.tsx,
        // keyed off the "coAppAutoEditKey" localStorage flag set above)
        // scrolls its section into view and opens it in edit mode once this
        // refetch re-renders it, so no scroll restore is needed here — the
        // customer is taken straight to the new section instead of staying
        // wherever the "Add More" button happened to be.
        await fetchData();
        await fetchCoApplicantCountFromApi(trackingId);

        // Always overwrite Formik values for the new co-applicant fields to avoid stale data
        // if (formikRef?.current) {
        //   newFields.forEach((field: any) => {
        //     let defaultValue: any = "";

        //     if (
        //       field.type === "dropdown" &&
        //       field.options?.options?.length > 0
        //     ) {
        //       // defaultValue =
        //       //   field.options.options[0]?.value ??
        //       //   field.options.options[0] ??
        //       //   "";
        //       defaultValue = ""; // Always empty by default
        //     } else if (field.type === "boolean") {
        //       defaultValue = false;
        //     }
        //     // Always overwrite, even if Formik already has a value for this key
        //     formikRef.current.setFieldValue(field.name, defaultValue, false);
        //   });
        // }
      }
    } catch (err) {
      console.error("Add entry failed", err);
      localStorage.removeItem(`coAppAutoEditKey_${trackingId}`);
      restoreScrollPositions(scrollSnapshot);
    } finally {
      setIsLoading(false);
    }
  };
  // Whether a co-applicant genuinely has saved data. Looks across the two
  // places co-applicant basic/address/employment fields get persisted:
  //   1. "Applicant & Loan Details" horizontal step → "Co-Applicant Details" vertical
  //   2. "Additional Details & Documents" horizontal step → "Co-Applicant
  //      Additional Details" vertical (backend has shipped this name both
  //      with and without the typo, so both spellings are matched)
  //
  // Hits the fetch-application-data API directly (same call fetchData()
  // uses) rather than reading the Redux-cached fetchUserApplicationData, so
  // this always checks against the latest server state instead of a
  // snapshot that may be stale (e.g. a co-applicant saved just moments ago
  // elsewhere in the same session).
  const isCoApplicantSavedInApplicationData = async (
    coApplicantNumber: number | string,
  ): Promise<boolean> => {
    let steps: any[] | undefined;
    try {
      const res: any = await fetchUserApplicationsFormData(
        token,
        applicationNumber,
      );
      steps = res?.data?.applications?.[0]?.horizontalSteps;
    } catch (err) {
      console.error(
        "Error fetching application data for isCoApplicantSavedInApplicationData",
        err,
      );
    }
    if (!Array.isArray(steps)) {
      // Fall back to the last known Redux snapshot if the fresh fetch failed.
      steps = fetchUserApplicationData?.horizontalSteps;
    }
    if (!Array.isArray(steps)) return false;

    const applicantLoanStep = steps.find(
      (step: any) => step?.horizontalStepName === "Applicant & Loan Details",
    );
    const documentsStep = steps.find(
      (step: any) =>
        step?.horizontalStepName === "Additional Details & Documents",
    );

    const loanDetailsVStep = applicantLoanStep?.verticalSteps?.find(
      (vStep: any) => vStep?.verticalStepName === "Co-Applicant Details",
    );
    const coApplicantAdditionalDetailsVStep = documentsStep?.verticalSteps?.find(
      (vStep: any) =>
        vStep?.verticalStepName === "Co-Applicant Additional Details" ||
        vStep?.verticalStepName === "Co-Applicant Aditional Details",
    );

    const fieldNameRegex = new RegExp(
      `^(basic|address|employment)CoApplicant${coApplicantNumber}(?!\\d)`,
    );

    const vStepHasSavedCoApplicantField = (vStep: any): boolean => {
      if (!Array.isArray(vStep?.fields)) return false;
      return vStep.fields.some((fieldObj: any) => {
        if (!fieldObj || typeof fieldObj !== "object") return false;
        const key = Object.keys(fieldObj)[0];
        if (!key || !fieldNameRegex.test(key)) return false;
        const rawValue = fieldObj[key];
        const resolved =
          rawValue && typeof rawValue === "object"
            ? (rawValue as any).value ?? (rawValue as any).label
            : rawValue;
        return String(resolved ?? "").trim() !== "";
      });
    };

    return (
      vStepHasSavedCoApplicantField(loanDetailsVStep) ||
      vStepHasSavedCoApplicantField(coApplicantAdditionalDetailsVStep)
    );
  };

  const executeRemoveCoApplicant = async (coApplicantNumber: number) => {
    if (coApplicantNumber <= 1) return;

    // Removing a co-applicant briefly collapses the whole accordion list
    // down to skeleton cards the same way saving/Add More does — restore
    // the scroll position afterward so the page doesn't jump to the top.
    const scrollSnapshot = snapshotScrollPositions();
    setIsLoading(true);
    try {
      const coApplicantType = `Co-Applicant ${coApplicantNumber}`;
      // Only ask LOS for this co-applicant (and only delete it) when it
      // genuinely has saved data — otherwise getCoApplicantDetails 404s
      // every time for a co-applicant that was never persisted, which is
      // just noise since there's nothing there to delete.
      const hasSavedCoApplicantData = await isCoApplicantSavedInApplicationData(
        coApplicantNumber,
      );
      let applicantIdForDelete = "0";
      let losCoApplicantDetailsResp: any = null;
      await getCoApplicantFieldIds(horizontalSteps,coApplicantNumber);
      if (hasSavedCoApplicantData) {
        try {
          const resp: any = await losServices.getCoApplicantDetails({
            trackingId,
            coApplicantType,
          });
          losCoApplicantDetailsResp = resp;
          const apiApplicantId = resp?.data?.data?.applicantId;
          applicantIdForDelete =
            apiApplicantId === null || apiApplicantId === undefined
              ? "0"
              : apiApplicantId || "0";
        } catch (err) {
          applicantIdForDelete = "0";
        }
      }

      const fieldPrefixRegex = new RegExp(
        `^(basic|address|employment)CoApplicant${coApplicantNumber}`,
        "i",
      );
      let coApplicantFieldIdsToDelete: number[] = [];

      const losData = losCoApplicantDetailsResp?.data?.data;
      const losCandidates = [
        Array.isArray(losData) ? losData : null,
        Array.isArray(losData?.data) ? losData.data : null,
        Array.isArray(losData?.formData) ? losData.formData : null,
        Array.isArray(losData?.coApplicantDetails) ? losData.coApplicantDetails : null,
      ].filter(Boolean) as any[][];

      const losFormRows = losCandidates.flatMap((rows) => rows);
      if (losFormRows.length > 0) {
        coApplicantFieldIdsToDelete = losFormRows
          .filter((row: any) =>
            fieldPrefixRegex.test(String(row?.fieldKey || row?.formFieldKey || "")),
          )
          .map((row: any) => Number(row?.formFieldId ?? row?.fieldId ?? row?.id))
          .filter((id: number) => Number.isFinite(id));
      } 

      coApplicantFieldIdsToDelete=getCoApplicantFieldIds(horizontalSteps,coApplicantNumber)
      try {
        if (coApplicantFieldIdsToDelete.length === 0) {
          const coApplicantFieldsResp: any = await losServices.getCoApplicantFields();
          const rawFields = coApplicantFieldsResp?.data?.data;
          const coApplicantFields = Array.isArray(rawFields)
            ? rawFields
            : Array.isArray(rawFields?.formFields)
              ? rawFields.formFields
              : [];

          coApplicantFieldIdsToDelete = coApplicantFields
            .filter((field: any) => {
              const fieldName = String(field?.name || "");
              return fieldPrefixRegex.test(fieldName);
            })
            .map((field: any) => Number(field?.id))
            .filter((id: number) => Number.isFinite(id));
        }
      } catch (coFieldErr) {
        console.error("Error fetching co-applicant fields for delete", coFieldErr);
      }
      // Track each delete call's outcome (null = never attempted) so the
      // final status popup can show success if any of them went through,
      // and only show an error when every attempted call failed.
      let deleteUserFieldsSucceeded: boolean | null = null;
      let deleteCoApplicantSucceeded: boolean | null = null;
      let processioDeleteSucceeded: boolean | null = null;

      if (hasSavedCoApplicantData) {
        try {
          const deleteResp: any = await applicationDetailsServices.deleteCoApplicant(
            trackingId,
            coApplicantType,
          );
          const deleteStatus = deleteResp?.data?.status;
          deleteCoApplicantSucceeded =
            !deleteStatus || String(deleteStatus).toLowerCase() === "success";
        } catch (deleteCoApplicantErr) {
          deleteCoApplicantSucceeded = false;
          console.error("Error calling delete-coapplicant API", deleteCoApplicantErr);
        }

        // Saved co-applicant: stop here if delete-coapplicant failed —
        // delete-user-fields below only runs after it succeeds.
        if (deleteCoApplicantSucceeded === false) {
          dispatch(
            setStatusPopup({
              status: "error",
              message: "Co-applicant cannot be deleted as they are added as a co-owner in collateral.",
            }),
          );
          return;
        }

        try {
          processioDeleteSucceeded = true;
        } catch (procErr) {
          processioDeleteSucceeded = false;
          console.error("Error calling ProcessIO delete-co-applicant API", procErr);
        }
      }

      // Saved co-applicant: delete-user-fields only runs after
      // delete-coapplicant succeeded above; unsaved: called straight away.
      if (coApplicantFieldIdsToDelete.length > 0) {
        const deleteUserFieldsPayload = {
          form_field_ids: coApplicantFieldIdsToDelete,
          trackingId: trackingId,
        };
        try {
          await postsServices.addPost(
            "api/v1/product/delete-user-fields",
            deleteUserFieldsPayload,
          );
          deleteUserFieldsSucceeded = true;
        } catch (deleteFieldsErr) {
          deleteUserFieldsSucceeded = false;
          console.error(
            "Error calling delete-user-fields API for co-applicant",
            deleteFieldsErr,
          );
        }
      }

      const attemptedDeleteResults = [
        deleteUserFieldsSucceeded,
        deleteCoApplicantSucceeded,
        processioDeleteSucceeded,
      ].filter((result): result is boolean => result !== null);
      const allDeletesFailed =
        attemptedDeleteResults.length > 0 &&
        attemptedDeleteResults.every((result) => result === false);

      const removeCoApplicantFieldsFromSteps = (steps: any[] = []) =>
        steps.map(
          (hStep: any, hIdx: number) => {
            const matchedConfig = CO_APPLICANT_SOURCE_STEPS.find(
              (step) => step.horizontalIndex === hIdx,
            );
            if (!matchedConfig || !Array.isArray(hStep?.verticalSteps)) return hStep;

            const targetVIdx = matchedConfig.verticalIndex;
            if (targetVIdx < 0 || targetVIdx >= hStep.verticalSteps.length) {
              return hStep;
            }

            const updatedVerticalSteps = [...hStep.verticalSteps];
            const targetStep = { ...updatedVerticalSteps[targetVIdx] };
            targetStep.fields = (targetStep.fields || []).filter((fieldObj: any) => {
              const key = fieldObj?.name || Object.keys(fieldObj || {})?.[0] || "";
              return !fieldPrefixRegex.test(String(key));
            });
            updatedVerticalSteps[targetVIdx] = targetStep;

            return {
              ...hStep,
              verticalSteps: updatedVerticalSteps,
            };
          },
        );

      const state = store.getState();
      if (Array.isArray(state?.stepper?.horizontalSteps)) {
        const updatedSteps = removeCoApplicantFieldsFromSteps(state.stepper.horizontalSteps);

        dispatch(setHorizontalSteps(updatedSteps));
        const updatedFormData = Object.fromEntries(
          Object.entries(formData || {}).filter(([key]) => !fieldPrefixRegex.test(key)),
        );
        dispatch(clearFormData());
        dispatch(updateFormData(updatedFormData));
        if (fetchUserApplicationData && typeof fetchUserApplicationData === "object") {
          dispatch(
            setFetchUserApplicationData({
              ...fetchUserApplicationData,
              horizontalSteps: updatedSteps,
            }),
          );
        }
      }
      const coApplicantKey = `coapplicant${coApplicantNumber}`.toLowerCase();
      const removeCoApplicantFromDetails = (input: any) => {
        if (!input) return input;
        if (Array.isArray(input)) {
          return input.filter((entry: any) => {
            const keys = Object.keys(entry || {}).map((k) => String(k)?.toLowerCase());
            return !keys.includes(coApplicantKey);
          });
        }
        if (typeof input === "object") {
          const next = { ...input };
          delete (next as any)[`coapplicant${coApplicantNumber}`];
          delete (next as any)[`coapplicant${coApplicantNumber}Id`];
          delete (next as any)[`coapplicant${coApplicantNumber}id`];
          return next;
        }
        return input;
      };
      const updatedCoApplicantDetails = removeCoApplicantFromDetails(reduxCoApplicantDetails);
      coApplicantDetailsRef.current = updatedCoApplicantDetails;
      dispatch(setCoApplicantDetails(updatedCoApplicantDetails));
     
      dispatch(
        setStatusPopup(
          allDeletesFailed
            ? {
                status: "error",
                message: "Unable to remove co-applicant. Please try again.",
              }
            : {
                status: "success",
                message: `Co-Applicant removed successfully.`,
              },
        ),
      );
      await fetchData();
      const latestFetchUserApplicationData =
        store.getState()?.stepper?.fetchUserApplicationData;
      if (
        latestFetchUserApplicationData &&
        Array.isArray(latestFetchUserApplicationData?.horizontalSteps)
      ) {
        const updatedStepsAfterFetch = removeCoApplicantFieldsFromSteps(
          latestFetchUserApplicationData.horizontalSteps,
        );
        dispatch(setHorizontalSteps(updatedStepsAfterFetch));
        dispatch(
          setFetchUserApplicationData({
            ...latestFetchUserApplicationData,
            horizontalSteps: updatedStepsAfterFetch,
          }),
        );
      }
      await dispatch(
        getFormJson({
          product: selectedProduct || "SLI",
          loaderShow: false,
          trackingId,
        }),
      );
      await fetchCoApplicantCountFromApi(trackingId);
    } catch (err) {
      console.error("Error removing co-applicant", err);
      // dispatch(
      //   setStatusPopup({
      //     status: "error",
      //     message: "Unable to remove co-applicant. Please try again.",
      //   }),
      // );
    } finally {
      setIsLoading(false);
      restoreScrollPositions(scrollSnapshot);
    }
  };
  const handleRemoveCoApplicant = (coApplicantNumber: number) => {
    if (coApplicantNumber <= 1) return;
    setPendingRemoveCoApplicantNumber(coApplicantNumber);
    setConfirmRemoveOpen(true);
  };

  const handleCancelRemoveCoApplicant = () => {
    setConfirmRemoveOpen(false);
    setPendingRemoveCoApplicantNumber(null);
  };

  const handleConfirmRemoveCoApplicant = async () => {
    if (pendingRemoveCoApplicantNumber === null) return;
    const coApplicantNumber = pendingRemoveCoApplicantNumber;
    setConfirmRemoveOpen(false);
    setPendingRemoveCoApplicantNumber(null);
    await executeRemoveCoApplicant(coApplicantNumber);
  };
  useEffect(() => {
    const breObj = breData;
    const isBlankObject =
      breObj &&
      Object.keys(breObj).length > 0 &&
      Object.values(breObj).every(
        (v) => v === "" || v === null || v === undefined
      );
    if (isBlankObject === undefined) {
      setIsBreDataFlag(false);
    } else {
      setIsBreDataFlag(!isBlankObject);
    }
  }, [breData, applicationNumber]);
    const transformCoApplicantObjectToArray = (input: any) => {
    if (!input || Array.isArray(input) || typeof input !== "object") return input;
    const entries = Object.entries(input).filter(([k]) => /^coapplicant\d+$/i.test(k));
    if (entries.length === 0) return input;
    return entries
      .sort(([a], [b]) => {
        const numA = parseInt(String(a).replace(/[^\d]/g, ""), 10);
        const numB = parseInt(String(b).replace(/[^\d]/g, ""), 10);
        return numA - numB;
      })
      .map(([key, value]: [string, any]) => {
        const fields:any = [{}];
        return {
          [key]: fields,
          [`${key}Id`]: value?.coApplicantId,
        };
      });
  };

  // utils.js

// utils.ts
  // Helper to map co-applicant fields from multiple vertical steps to the required format
  function mapCoApplicantDetailsFromVerticalSteps(verticalSteps: any[]) {
    const mergedFields = (Array.isArray(verticalSteps) ? verticalSteps : [])
      .flatMap((verticalStep: any) => verticalStep?.fields || [])
      .filter((fieldObj: any, index: number, allFields: any[]) => {
        const currentKey = Object.keys(fieldObj || {})[0];
        return (
          allFields.findIndex((candidate: any) => {
            const candidateKey = Object.keys(candidate || {})[0];
            return candidateKey === currentKey;
          }) === index
        );
      });

    if (mergedFields.length === 0) return [];
    // Group fields by co-applicant number
    const coAppMap: { [key: string]: any[] } = {};
    const coAppIdMap: { [key: string]: any } = {};
    mergedFields.forEach((fieldObj: any) => {
      const key: string = Object.keys(fieldObj)?.[0] as string;
      const value: CoApplicantFieldValue = fieldObj?.[key];

      // Try to extract co-applicant number from key (e.g., coApplicant1Name, coApplicant2PanNumber, etc.)
      const match: RegExpMatchArray | null =
        key.match(/CoApplicant(\d+)/i) || key.match(/coApplicant(\d+)/i);
      if (!match) return;
      const coAppNum = match[1];
      const coAppKey = `coapplicant${coAppNum}`;
      if (!coAppMap[coAppKey]) coAppMap[coAppKey] = [];

      // Normalize label and key as per requirements
      // Helper to remove known prefixes and format label
      function stripPrefixAndFormat(str: string) {
        // Remove known prefixes
        const prefixPattern =
          /^(basicCoApplicant\d+|addressCoApplicant\d+|employmentCoApplicant\d+)/i;
        const noPrefix = str.replace(prefixPattern, "");
        // Convert camelCase or snake_case to Title Case
        return noPrefix
          .replace(/([A-Z])/g, " $1")
          .replace(/_/g, " ")
          .replace(/^./, (s) => s.toUpperCase())
          .trim();
      }
      let label = fieldObj?.label || stripPrefixAndFormat(key);
      if (/OtherRelationWithStudent/i.test(key)) label = "Specify Relationship";
      else if (/RelationWithStudent/i.test(key)) label = "Relationship with Student";
      else if (/FirstName/i.test(key)) label = "Co-Applicant First Name";
      else if (/LastName/i.test(key)) label = "Co-Applicant Last Name";
      else if (/PanNumber/i.test(key)) label = "PAN Number";
      else if (/IsPanVerified/i.test(key)) label = "PAN Verified";
      else if (/Email$/i.test(key) && !/IsEmailVerified/i.test(key))
        label = "Email ID";
      else if (/IsEmailVerified/i.test(key)) label = "Email Verified";
      else if (/Phone_number/i.test(key)) label = "Mobile Number";
      else if (/IsMobileVerified/i.test(key)) label = "Mobile Verified";

      // Use correct name property for output
      let name = key;
      if (/RelationWithStudent/i.test(key))
        name = `coApplicant${coAppNum}RelationWithStudent`;
      else if (/Name/i.test(key)) name = `coApplicant${coAppNum}Name`;
      else if (/PanNumber/i.test(key)) name = `coApplicant${coAppNum}PanNumber`;
      else if (/IsPanVerified/i.test(key))
        name = `coApplicant${coAppNum}IsPanVerified`;
      else if (/Email$/i.test(key) && !/IsEmailVerified/i.test(key))
        name = `coApplicant${coAppNum}Email`;
      else if (/IsEmailVerified/i.test(key))
        name = `coApplicant${coAppNum}IsEmailVerified`;
      else if (/Phone_number/i.test(key))
        name = `coApplicant${coAppNum}Phone_number`;
      else if (/IsMobileVerified/i.test(key))
        name = `coApplicant${coAppNum}IsMobileVerified`;

      coAppMap[coAppKey].push({
        label,
        name,
        key,
        value,
      });

      // Optionally, extract co-applicant ID if present
      if (/Id$/.test(key)) {
        coAppIdMap[coAppKey] = value;
      }
    });

    // Build the final array, sorted by co-applicant number
    const grouped: any[] = Object.keys(coAppMap)
      .sort((a, b) => {
        // Extract numbers from keys like 'coapplicant1', 'coapplicant2', etc.
        const numA = parseInt(a.replace(/[^\d]/g, ""), 10);
        const numB = parseInt(b.replace(/[^\d]/g, ""), 10);
        return numA - numB;
      })
      .map((coAppKey) => ({
        [coAppKey]: coAppMap[coAppKey],
        [`${coAppKey}Id`]: coAppIdMap[coAppKey],
      }));

    return grouped;
  }

  let coApplicantToShow = stableCoApplicantDetails;
  if (
    fetchUserApplicationData &&
    !fetchUserApplicationData?.partnerStartedJourney
  ) {
    const coApplicantSourceVerticalSteps = CO_APPLICANT_SOURCE_STEPS.map(
      ({ horizontalIndex, verticalIndex }) =>
        fetchUserApplicationData?.horizontalSteps?.[horizontalIndex]?.verticalSteps?.[
          verticalIndex
        ],
    ).filter(Boolean);
    
    coApplicantToShow = mapCoApplicantDetailsFromVerticalSteps(
      coApplicantSourceVerticalSteps,
    );
  }
  const coApplicantSourceVerticalStepsone = CO_APPLICANT_SOURCE_STEPS.map(
    ({ horizontalIndex, verticalIndex }) =>
      horizontalSteps?.[horizontalIndex]?.verticalSteps?.[
        verticalIndex
      ],
  ).filter(Boolean);
  
  // If coApplicant is an object map (for partnerStartedJourney true), normalize to array
  coApplicantToShow = transformCoApplicantObjectToArray(coApplicantToShow);
  const normalizedCoApplicantToShow = Array.isArray(coApplicantToShow)
    ? coApplicantToShow
    : coApplicantToShow
      ? transformCoApplicantObjectToArray(coApplicantToShow) ?? []
      : [];
  coApplicantToShow = mergeMissingCoApplicants(
    normalizedCoApplicantToShow,
    coApplicantSourceVerticalStepsone,
  );
  stableCoApplicantDetails = syncResponse1ToResponse2(
    coApplicantToShow,
    stableCoApplicantDetails,
  );
  
  
  return (
    <Box>
      {isLoading ? (
        <Grid container spacing={3}>
          {[1, 2, 3, 4, 5]?.map((item) => (
            <Grid item xs={12} key={item}>
              <Card
                sx={{
                  borderRadius: "10px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  p: 2,
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                    transform: "translateY(-2px)",
                    transition: "all 0.3s ease-in-out",
                  },
                }}
              >
                <CardContent sx={{ p: "16px !important" }}>
                  <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                      <Skeleton
                        variant="rectangular"
                        width={35}
                        height={35}
                        sx={{ borderRadius: "8px" }}
                      />
                    </Grid>
                    <Grid item xs>
                      <Skeleton
                        variant="text"
                        width="60%"
                        height={20}
                        sx={{ mb: 1 }}
                      />
                      <Skeleton variant="text" width="80%" height={16} />
                    </Grid>
                    <Grid item>
                      <Box
                        display="flex"
                        alignItems="center"
                        sx={{ minWidth: "100px", justifyContent: "flex-end" }}
                      >
                        <Skeleton
                          variant="text"
                          width={60}
                          height={25}
                          sx={{ mr: 1 }}
                        />
                        <Skeleton variant="circular" width={24} height={24} />
                        <Skeleton
                          variant="circular"
                          width={24}
                          height={24}
                          sx={{ ml: 1 }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box>
          {data?.map((application, appIndex) => {
           
            const IconComponent =
              memoizedIcons[application?.label] || DocumentIcon;

            const iconProps =
              IconComponent === CustomImageIcon
                ? { src: iconSrcMap[application?.label] }
                : {};

              const defaultApplicantLoanDetailsTabs: VerticalStep[] = [
                { verticalStepName: "Student Details", fields: [] },
                { verticalStepName: "Address Details", fields: [] },
                { verticalStepName: "Employment Details", fields: [] },
                { verticalStepName: "Academic Details", fields: [] },
                { verticalStepName: "Entrance Exam Details", fields: [] },
                // { verticalStepName: "Loan Details", fields: [] },
              ];
              const defaultAdditionalDetailsTabs: VerticalStep[] = [
               { verticalStepName: "Applicant Additional Details", fields: [] },
                { verticalStepName: "Funds & Expenses", fields: [] },
                { verticalStepName: "Reference Details", fields: [] },
                { verticalStepName: "Collateral Details", fields: [] },
              ];

           // let innerDataToUse: VerticalStep[] = application?.innerData || [];
            let innerDataToUse: VerticalStep[] = splitReferenceCollateralVerticalSteps(
              application?.innerData?.filter((step:any) => {
              const verticalStepName = String(step?.verticalStepName || "").toLowerCase();
              const isCoAppStep = step.verticalStepName==="Co-Applicant Aditional Details";
              const isLoanDetailsStep = verticalStepName === "co-applicant details";
              const isCoApplicantDetailsStep = verticalStepName === "co-applicant details";
              // Skip co-app step + Loan Details step + Co-Applicant Details step on summary
              return !isCoAppStep && !isLoanDetailsStep && !isCoApplicantDetailsStep;
            }) ?? [],
            );
           
            const defaultStepsForSection = getDefaultVerticalStepsForSection(
              application?.label || "",
            );
            if (
              fetchUserApplicationData?.partnerStartedJourney === false &&
              defaultStepsForSection.length > 0
            ) {
              innerDataToUse = mergeVerticalStepsWithDefaults(
                innerDataToUse,
                defaultStepsForSection,
              );
            } else if (innerDataToUse.length === 0) {
              if (application?.label === "Applicant & Loan Details") {
                innerDataToUse = defaultApplicantLoanDetailsTabs;
              } else if (
                application?.label === "Additional Details & Documents"
              ) {
                innerDataToUse = defaultAdditionalDetailsTabs;
              }
            }
           
            const isCoApplicantSection = application?.label === "Co-Applicant";
            const shouldShowCoApplicantTabs =
              isCoApplicantSection && innerDataToUse.length === 0;
            const isEditableSection =
              application?.label === "Eligibility Check" ||
              application?.label === "Applicant & Loan Details";
            const activeVerticalStep = innerDataToUse[tabIndex];
            const activeSectionAction = activeVerticalStep
              ? eligibilitySectionActionMap[
                  activeVerticalStep.verticalStepName || ""
                ]
              : undefined;
            const isEditingActiveTab =
              editingStep?.appLabel === application?.label &&
              editingStep?.verticalStepName ===
                activeVerticalStep?.verticalStepName;
              // Entrance Exam Details = horizontalSteps[1].verticalSteps[4]
              const isEntranceExamStepDone = Boolean(
                fetchUserApplicationData?.horizontalSteps?.[1]?.verticalSteps?.[4]
              );
              // Co-Applicant Additional Details = horizontalSteps[3].verticalSteps[1]
              const hasReachedCoApplicantAdditionalDetailsStage = Boolean(
                fetchUserApplicationData?.horizontalSteps?.[3]?.verticalSteps?.[1]
              );
              // Applicant Additional Details = horizontalSteps[3].verticalSteps[0]
              const hasApplicantAdditionalDetailsAdded = Boolean(
                fetchUserApplicationData?.horizontalSteps?.[3]?.verticalSteps?.[0]
              );
              const isProvisionalGeneratedFlag =
                fetchUserApplicationData?.isProvisionalGenerated === true;
              const isAssistedJourney =
                fetchUserApplicationData?.partnerStartedJourney === true;
              // Assisted journeys that reached the co-applicant stage without an actual provisional offer
              const isProvisionalBypassed =
                isAssistedJourney && !isProvisionalGeneratedFlag;

              const coApplicantSummaryCards =
                shouldShowCoApplicantTabs && coApplicantToShow ? (
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {Object.entries(coApplicantToShow || {}).map(
                      ([key, value]: [string, any], index:number) => {
                        // 1. Dynamically get the inner coapplicant key (e.g., "coapplicant1", "coapplicant3")
                        const dynamicCoAppKey = Object.keys(value || {})[0]; 
                        const dataVal = value[dynamicCoAppKey];

                        // 2. Extract number from the key itself (or from internal dataVal[0].key)
                        const match = dynamicCoAppKey?.match(/\d+/) || dataVal?.[0]?.key?.match(/\d+/);
                        const coAppNum = match ? parseInt(match[0], 10) : null;

                        // 3. Compute progress dynamically
                        const completionRate = getCoApplicantAverageProgress(
                          percentageValue,
                          `coApplicant${coAppNum}`
                        );
                        const isCoApplicantIncomplete = completionRate !== 100;
                        // 1 & 3: entrance exam done (organic or assisted journey alike)
                        // 2: provisional generated and co-applicant stage reached
                        // 4: assisted + provisional bypassed, reached co-applicant stage, applicant additional details added
                        const canCompleteCoApplicantNow =
                          isCoApplicantIncomplete &&
                          (isEntranceExamStepDone ||
                            (isProvisionalGeneratedFlag &&
                              hasReachedCoApplicantAdditionalDetailsStage) ||
                            (isProvisionalBypassed &&
                              hasReachedCoApplicantAdditionalDetailsStage &&
                              hasApplicantAdditionalDetailsAdded));

                        return (
                          <Grid item xs={12} sm={6} md={4} key={key}>
                            <Card
                              sx={{
                                borderRadius: "12px",
                                border: "1px solid rgba(15, 23, 42, 0.08)",
                                boxShadow: "0px 4px 12px rgba(15, 23, 42, 0.04)",
                                backgroundColor: "#ffffff",
                              }}
                            >
                              <CardContent
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  gap: 1.5,
                                  px: 2,
                                  py: 1.5,
                                  "&:last-child": { pb: 1.5 },
                                }}
                              >
                                <Box sx={{ minWidth: 0 }}>
                                  <Typography
                                    sx={{
                                      fontSize: "0.82rem",
                                      fontWeight: 700,
                                      color: "#344054",
                                    }}
                                  >
                                    Co-Applicant {index + 1}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      fontSize: "0.68rem",
                                      fontWeight: 600,
                                      color: canCompleteCoApplicantNow ? "#00b3b5" : "gray",
                                      mt: 0.7,
                                      cursor: canCompleteCoApplicantNow ? "pointer" : "default",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onClick={() => {
                                      if (canCompleteCoApplicantNow) {
                                        gotoDynamicForm();
                                      }
                                    }}
                                  >
                                    {completionRate === 100
                                      ? "Completed"
                                      :!canCompleteCoApplicantNow?
                                      "Locked"
                                      : fetchUserApplicationData?.status==="Application Submitted"?"Locked": "Complete Now"}

                                    {canCompleteCoApplicantNow && (
                                      <ArrowForwardIosIcon
                                        sx={{
                                          fontSize: "0.55rem",
                                          color: "#00b3b5",
                                          ml: 0.5,
                                        }}
                                      />
                                    )}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "0.78rem",
                                      fontWeight: 700,
                                      color: "#00b3b5",
                                    }}
                                  >
                                    {completionRate}%
                                  </Typography>

                                  <Box
                                    sx={{
                                      position: "relative",
                                      display: "inline-flex",
                                    }}
                                  >
                                    <CircularProgress
                                      variant="determinate"
                                      value={100}
                                      size={28}
                                      thickness={4}
                                      sx={{ color: "#dff3f3" }}
                                    />

                                    <CircularProgress
                                      variant="determinate"
                                      value={completionRate}
                                      size={28}
                                      thickness={4}
                                      sx={{
                                        color: "#00b3b5",
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                      }}
                                    />
                                  </Box>
                                </Box>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      }
                    )}
                  </Grid>
                ) : null;
            const overAllCoAppRate=getCoAppPercentageByIndices(percentageValue,coApplicantToShow);
            const totalCoApplicantCount = Array.isArray(coApplicantToShow)
              ? coApplicantToShow.filter((coAppObj: any) =>
                  Object.keys(coAppObj || {}).some((k) => /^coapplicant\d+$/.test(k)),
                ).length
              : 0;
          
            return (
              <CollapsibleSection
                    key={application?.label}
                    icon={() => pageTypeSummary === "loansummary" ? null :<IconComponent {...iconProps} />}
                    title={application?.label}
                    subtitle={`${application?.label} Related Details`}
                    completionRate={
                      application?.label.toLowerCase() === "provisional offer letter"
                        ? undefined
                        : application?.label === "Co-Applicant"
                        ? `${overAllCoAppRate ? overAllCoAppRate : 0}%`
                        : String(application?.completionRate)
                    }
                    isCompleted={application?.status === "completed"}
                    isExpanded={expandedSection === appIndex || pageTypeSummary === "loansummary" }
                    onToggle={() => onToggleHandler(application, appIndex)}
                    subSteps={innerDataToUse}
                    isProvisionalOfferTab={
                      application?.label.toLowerCase() ===
                      "provisional offer letter"
                    }
                    provisionalOfferBtnClick={() =>
                      fetchUserApplicationData?.isProvisionalGenerated=== false
                        ? setOpenPendingModal(true)
                        : setIsViewProvisionalOfferModalOpen(true)
                    }
                    isProvisionalOffer={isBreDataFlag}
                    isProvisionalGenerated={fetchUserApplicationData?.isProvisionalGenerated === true}
                    partnerStartedJourney={fetchUserApplicationData?.partnerStartedJourney}
                    headerContent={coApplicantSummaryCards}
                    pageTypeSummary={pageTypeSummary}
                    applicationStatus={fetchUserApplicationData?.status}
                  >
                    <Box>
                      {shouldShowCoApplicantTabs ? (
                        !stableCoApplicantDetails ? (
                          referenceDetailsSkeleton()
                        ) : (
                          <>
                          {(fetchUserApplicationData?.partnerStartedJourney===true ||  pageTypeSummary==="loansummary") &&
                            <CoApplicantTabs
                              coApplicant={coApplicantToShow}
                              pageTypeSummary={pageTypeSummary}
                              onRemoveCoApplicant={handleRemoveCoApplicant}
                              designationsVal={designations}
                            />
                          }
                            {pageTypeSummary!="summary" && fetchUserApplicationData?.partnerStartedJourney===false && fetchUserApplicationData?.status!=="Application Submitted" &&
                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                              <Button
                                disabled={totalCoApplicantCount >= 9}
                                sx={{
                                  textTransform: "none",
                                  fontFamily: "Jost, sans-serif",
                                  fontWeight: 600,
                                  fontSize: "14px",
                                  lineHeight: "100%",
                                  letterSpacing: "0%",
                                  color: "#33c2c4",
                                  borderColor: "#33c2c4",
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                    borderColor: "#33c2c4",
                                    color: "#33c2c4",
                                  },
                                  "&.Mui-disabled": {
                                    color: "#a5a3ae",
                                    borderColor: "#d7e3e3",
                                  },
                                }}
                                onClick={() => addCoApplicantFields()}
                              >
                                <AddIcon sx={{ mr: 1, fontSize: "20px" }} />
                                Add More
                              </Button>
                            </Box>}
                          </>
                        )
                      ) : (
                        <>
                         { pageTypeSummary!=="loansummary" && fetchUserApplicationData?.partnerStartedJourney===true && 
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "flex-start",
                                alignItems: "center",
                              }}
                            >
                              <InnerDetailsTabs
                                innerData={innerDataToUse}
                                activeTabIndex={tabIndex}
                                activeHandleChange={handleChange}
                                isXsOrSm={isXsOrSm}
                              />
                            </Box>
                              <Box sx={{ mt: 2, width: "100%" }}>
                                {innerDataToUse?.map(
                                (verticalStep: VerticalStep, i: number) => (
                                  <TabPanel value={tabIndex} index={i} key={i}>
                                    <RenderTabContent
                                      applicationLabel={application?.label}
                                      verticalStep={verticalStep}
                                      isMobile={false}
                                      isLoanDetailsLoading={isLoanDetailsLoading}
                                      designationsVal={designations}
                                      maritalStatusMap={maritalStatusMap}
                                    />
                                  </TabPanel>
                                )
                              )}
                            </Box>
                          </Box>}

                        {(pageTypeSummary==="loansummary")  && (
                          <Box sx={{ mt: 2 }}>
                            {innerDataToUse?.map(
                              (verticalStep: VerticalStep, verticalIndex: number) => {
                                const horizontalIndex = getHorizontalIndexFromLabel(application?.label || "");
                                const verticalIndexLabel = resolveEditorVerticalStepLabel(
                                  application?.label || "",
                                  verticalStep?.verticalStepName || "",
                                  verticalIndex,
                                  reduxHorizontalSteps,
                                );
                                const reduxVerticalIndex = resolveReduxVerticalIndex(
                                  verticalStep?.verticalStepName || "",
                                  application?.label,
                                  reduxHorizontalSteps,
                                );
                                const initialReferenceCollateralTab =
                                  verticalStep?.verticalStepName === "Collateral Details"
                                    ? 1
                                    : 
                                    verticalStep?.verticalStepName === "Reference Details"
                                      ? 0
                                      : undefined;
                                
                                return (
                                <Card
                                  key={verticalIndex}
                                  sx={{
                                    mb: 2,
                                    borderRadius: "10px",
                                    border: "1px solid #D7E3E3",
                                    boxShadow: "none",
                                    overflow: "hidden",
                                  }}
                                >
                                  {/* Header */}
                                  <Box
                                    sx={{
                                      px: 2,
                                      py: 1.5,
                                      background: "#EDF6F6",
                                      borderBottom: "1px solid #D7E3E3",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        fontSize: "14px",
                                        fontWeight: 700,
                                        color: "#1F2937",
                                      }}
                                    >
                                      {verticalStep?.verticalStepName}
                                    </Typography>
                                    {(() => {
                                      const action =
                                        eligibilitySectionActionMap[
                                          verticalStep?.verticalStepName || ""
                                        ];
                                      const isEditingCurrentRow =
                                        editingStep?.appLabel ===
                                          application?.label &&
                                        editingStep?.verticalStepName ===
                                          verticalStep?.verticalStepName;
                                      const rowActionLabel =
                                        isEditingCurrentRow &&
                                        action?.label === "Edit"
                                          ? "Save"
                                          : action?.label || "";
                                      // Applicant Additional Details stays editable for assisted
                                      // journeys once the provisional offer has been generated.
                                      const isApplicantAdditionalDetailsStep =
                                        verticalStep?.verticalStepName ===
                                        "Applicant Additional Details";
                                      const bypassPartnerLock =
                                        isApplicantAdditionalDetailsStep &&
                                        fetchUserApplicationData?.isProvisionalGenerated === true;
                                      
                                      if (!rowActionLabel || (fetchUserApplicationData?.partnerStartedJourney===true && !bypassPartnerLock) || fetchUserApplicationData?.status==="Application Submitted") return null;

                                      return (
                                      <SummaryRowAction
                                        rowActionLabel={rowActionLabel}
                                        clickable={Boolean(action?.clickable)}
                                        onSave={() => dispatch(requestSummaryFormSave("application"))}
                                        onEdit={() =>
                                          handleEditStep(
                                            application?.label,
                                            verticalStep?.verticalStepName,
                                            horizontalIndex,
                                            reduxVerticalIndex,
                                            verticalIndex
                                          )
                                        }
                                        onCancel={handleCancelEdit}
                                      />
                                      );
                                    })()}
                                  </Box>

                                  {/* Content */}
                                  <Box sx={{ p: 2 }}>
                                    {editingStep &&
                                    editingStep.appLabel === application?.label &&
                                    editingStep.verticalStepName ===
                                      verticalStep?.verticalStepName ? (
                                      <Box>
                                        <InlineErrorBoundary onReset={() => setEditingStep(null)}>
                                          <FormEdit 
                                            key={`${application?.label}-${verticalStep?.verticalStepName}`}
                                            fields={getEditorFields(application?.label, verticalIndexLabel, verticalStep?.verticalStepName)}
                                            pageType={"SUMMARY"}
                                            activeHorizontalIndex={horizontalIndex}
                                            activeVerticalIndex={reduxVerticalIndex}
                                            initialReferenceCollateralTab={initialReferenceCollateralTab}
                                            fetchData={fetchData}
                                          />
                                        </InlineErrorBoundary>
                                      </Box>
                                    ) : (
                                      <RenderTabContent
                                        applicationLabel={application?.label}
                                        verticalStep={verticalStep}
                                        isMobile={false}
                                        isLoanDetailsLoading={isLoanDetailsLoading}
                                        designationsVal={designations}
                                        maritalStatusMap={maritalStatusMap}
                                        pageTypeSummary={pageTypeSummary}
                                      />
                                    )}
                                  </Box>
                                </Card>
                                );
                              }
                            )}
                          </Box>
                        )}
                        </>
                      )}
                    </Box>
                </CollapsibleSection>
            );
          })}

          <ModalPopup
            title=""
            isOpen={isOpenPendingModal}
            onClose={() => setOpenPendingModal(false)}
            style={{ width: "100%" }}
          >
            <PendingProvisionalOfferModalContent />
          </ModalPopup>

          <ModalPopup
            title=""
            isOpen={isViewProvisionalOfferModalOpen}
            onClose={() => setIsViewProvisionalOfferModalOpen(false)}
            style={
              isProvisionalOffer ? { maxWidth: "800px", width: "100%" } : {}
            }
          >
            <ProvisionalOfferModalContent />
          </ModalPopup>

          <ModalPopup
            isOpen={confirmRemoveOpen}
            onClose={handleCancelRemoveCoApplicant}
            subTitle="Remove Co-Applicant"
          >
            <Box sx={{ p: 2 }}>
              <Typography>
                Are you sure you want to remove this Co-Applicant? This action
                cannot be undone.
              </Typography>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
              >
                <Button
                  onClick={handleCancelRemoveCoApplicant}
                  color="primary"
                  size="small"
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleConfirmRemoveCoApplicant}
                  size="small"
                  variant="contained"
                  sx={{ backgroundColor: "#00b3b5", "&:hover": { backgroundColor: "#00b3b5" } }}
                >
                  Confirm
                </Button>
              </Box>
            </Box>
          </ModalPopup>

          <BottomSheet
            open={(pageTypeSummary === "loansummary" || (fetchUserApplicationData?.partnerStartedJourney)) && isBottomSheetOpen}
            onClose={handleCloseBottomSheet}
            contentBoxId="application-details-scroll-container"
          >
            {memoizedBottomSheetContent}
          </BottomSheet>
        </Box>
      )}
    </Box>
  );
};

export default ApplicationDetails;
